<div class="navbar-fixed-top z-index-10">
  <nav class="navbar app-header after-login">
    <div class="header-container">
      <input #myFileInputcandidate style="display: none;" type="file" (click)="myFileInputcandidate.value=null"
        (change)="fileChangeEvent($event, profilePhotoUpload)" accept=" .jpg, .jpeg, .png" />
      <div class="navbar-header orientyy">
        <a id="landing_navbar_brand_logo" class="navbar-brand" (click)="selectMenu('landingPage')" routerLinkActive="router-link-active">
          <img src="assets/icon/gigsumologo_bigface.png" class="bigface" alt="" />
        </a>
        <a joyrideStep="start.tour" [title]="getTourData('start.tour','title')"
          [text]="getTourData('start.tour','text')" [ngClass]="{'disabled': !gigsumoService.buttonClicked}"
          class="plus-icon iconText gs-nav-action" yPosition="below" xPosition="after" [matMenuTriggerFor]="menu"
          (done)="onLandingTourStepDone($event)">
          <ng-icon name="tablerCirclePlus"></ng-icon>
          <span title="Create">Create</span>
        </a>



        <div class="custom-drpdwn">
          <mat-menu #menu="matMenu">
            <button id="landing_navbar_create_job_button" *ngIf="showJobsButton" class="mat-menu-height" mat-menu-item
              (click)="createJobsOrCandidates('JOBS', jobCandidateTemplate)">
              <ng-icon name="tablerBriefcase" class="create-job-svg" style="font-size: 20px; position: relative; top: -2px; right: auto; left: auto;margin-right: 7px;"></ng-icon>
              <span class="skpax">Create a Job</span>
            </button>
            <button id="landing_navbar_create_candidate_button" *ngIf="showCandidateButton" type="button" class="mat-menu-height" mat-menu-item
              (click)="createJobsOrCandidates('CANDIDATE', jobCandidateTemplate)">
              <ng-icon name="tablerUserPlus" class="create-job-svg" style="font-size: 20px; position: relative; top: -2px; right: auto; left: auto;margin-right: 7px;"></ng-icon>
              <span>Create a Candidate</span>
            </button>
            <!-- <button *ngIf="showCandidateButton" type="button" class="mat-menu-height" mat-menu-item
              (click)="openCandidateTabForm()">
              <svg class="create-job-svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                <path d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                  stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13 3v5a2 2 0 002 2h4" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>Create Candidate (Tabbed)</span>
            </button> -->
          </mat-menu>
        </div>
        <a id="HomeView"
          *ngIf="userType != 'RECRUITER' &&  (userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
          class="plus-icon iconText gs-nav-action" yPosition="below" xPosition="after" [matMenuTriggerFor]="viewer">
          <ng-icon name="tablerEye"></ng-icon>
          <span title="View">View </span>
          <span class="badge view-notification"
            *ngIf="notificationDatasshow?.jobInvitesReceivedCount>0 || notificationDatasshow?.resumeRequestReceivedCount>0 || notificationDatasshow?.jobApplicationsReceivedCount>0 ">{{
            notificationDatasshow?.jobInvitesReceivedCount + notificationDatasshow?.resumeRequestReceivedCount +
            notificationDatasshow?.jobApplicationsReceivedCount }}</span>
        </a>
        <a id="HomeView" *ngIf="userType == 'RECRUITER'" class="plus-icon iconText gs-nav-action" yPosition="below" xPosition="after"
          [matMenuTriggerFor]="viewer">
          <ng-icon name="tablerEye"></ng-icon>
          <span title="View">View </span>
          <span class="badge view-notification" *ngIf="notificationDatasshow?.jobApplicationsReceivedCount>0 ">
            {{notificationDatasshow?.jobApplicationsReceivedCount }}</span>
        </a>
        <a id="HomeView" *ngIf="userType == 'BENCH_RECRUITER' || userType=='JOB_SEEKER'" class="plus-icon iconText gs-nav-action"
          yPosition="below" xPosition="after" [matMenuTriggerFor]="viewer">
          <ng-icon name="tablerEye"></ng-icon>
          <span title="View">View </span>
          <span class="badge view-notification"
            *ngIf="notificationDatasshow?.jobInvitesReceivedCount>0 || notificationDatasshow?.resumeRequestReceivedCount>0 ">{{
            notificationDatasshow?.jobInvitesReceivedCount + notificationDatasshow?.resumeRequestReceivedCount }}</span>
        </a>
        <div class="custom-drpdwn" id="tourThree">
          <mat-menu #viewer="matMenu">
            <button class="mat-menu-height pad-rt-30 pointer-events-none" mat-menu-item>
              <span class="ixym svg-position">
                <ng-icon name="tablerInbox" class="top-12"></ng-icon>
              </span>
              <span><b>Inbox</b></span>
            </button>
            <ng-container *ngFor="let item of labelsBasedonUserType(userType)">
              <button id="item.id" type="button" *ngIf="item.title=='Inbox'" (click)="widgetload(item.url, item.param)"
                class="mat-menu-height pad-rt-30-30" mat-menu-item>
                <span class="ixym svg-position">
                  <ng-icon name="tablerUserPlus" *ngIf="item.value == 'Job Invites Received'" 
                    class="top-12"></ng-icon>
                  <ng-icon name="tablerFileText" *ngIf="item.value == 'Resume Requests Received'" 
                    class="top-12"></ng-icon>
                  <ng-icon name="tablerUserCheck" *ngIf="item.value == 'Job Applicants'" 
                    class="top-12"></ng-icon>
                </span>
                <span title="{{item.value}}">{{truncateMiddle(item.value)}} <span *ngIf="item.count != null" style="color: #1272f0;">({{item.count}})</span>
                </span>
              </button>
            </ng-container>
            <button class="mat-menu-height pad-rt-30 pointer-events-none" mat-menu-item>
              <span class="ixym svg-position">
                <ng-icon name="tablerMailForward" class="top-12"></ng-icon>
              </span>
              <span><b>Outbox</b></span>
            </button>
            <ng-container *ngFor="let item of labelsBasedonUserType(userType)">
              <button id="item.id" type="button" *ngIf="item.title=='Outbox'" (click)="widgetload(item.url, item.param)"
                class="mat-menu-height pad-rt-30-30" mat-menu-item>
                <span class="ixym svg-position">
                  <ng-icon name="tablerUserPlus" *ngIf="item.value == 'Job Invites Sent'" 
                    class="top-12"></ng-icon>
                  <ng-icon name="tablerFileText" *ngIf="item.value == 'Resume Requests Sent'" 
                    class="top-12"></ng-icon>
                  <ng-icon name="tablerUserCheck" *ngIf="item.value == 'Jobs Applied'" 
                    class="top-12"></ng-icon>
                </span>
                <span title="{{item.value}}">{{truncateMiddle(item.value)}}<span *ngIf="item.count != null" style="color: #1272f0;">({{item.count}})</span>
                </span>
              </button>
            </ng-container>
            <button class="mat-menu-height pad-rt-30 pointer-events-none" mat-menu-item>
              <span class="ixym svg-position">
                <ng-icon name="tablerSparkles" class="top-12"></ng-icon>
              </span>
              <span><b>Marketplace</b></span>
            </button>
            <ng-container *ngFor="let item of labelsBasedonUserType(userType)">
              <button id="item.id" type="button" *ngIf="item.title=='Marketplace'"
                (click)="widgetload(item.url, item.param)" class="mat-menu-height pad-rt-30-30" mat-menu-item>
                <span class="ixym svg-position">
                  <ng-icon name="tablerFileText" *ngIf="item.value == 'Marketplace Candidates'" 
                    class="top-12"></ng-icon>
                  <ng-icon name="tablerUserCheck" *ngIf="item.value == 'Marketplace Jobs'" 
                    class="top-12"></ng-icon>
                </span>
                <span title="{{item.value}}">{{truncateMiddle(item.value)}}<span *ngIf="item.count != null" style="color: #1272f0;">({{item.count}})</span>
                </span>
              </button>
            </ng-container>
            <button class="mat-menu-height pad-rt-30 pointer-events-none" mat-menu-item>
              <span class="ixym svg-position">
                <ng-icon name="customPremium" class="top-12"></ng-icon>
              </span>
              <span><b>Featured</b></span>
            </button>
            <ng-container *ngFor="let item of labelsBasedonUserType(userType)">
              <button id="item.id" type="button" *ngIf="item.title=='Featured'"
                (click)="widgetload(item.url, item.param)" class="mat-menu-height pad-rt-30-30" mat-menu-item>
                <span class="ixym svg-position">
                  <ng-icon name="tablerFileText" *ngIf="item.value == 'Featured Jobs'" 
                    class="top-12"></ng-icon>
                  <ng-icon name="tablerUserCheck" *ngIf="item.value == 'Featured Candidates'" 
                    class="top-12"></ng-icon>
                </span>
                <span title="{{item.value}}">{{truncateMiddle(item.value)}}<span *ngIf="item.count != null" style="color: #1272f0;">({{item.count}})</span>
                </span>
              </button>
            </ng-container>
          </mat-menu>
        </div>
      </div>
      <!-- collapse navbar-collapse  -->
      <div class="flex-display-1">
        <form [formGroup]="serachForm" class="navbar-form navbar-left app-form example-form flex-1">
          <div class="gs-search-box gs-search-box--navbar">
            <span class="global-search-svg-icon">
              <ng-icon name="tablerSearch"></ng-icon>
            </span>
            <input type="text" placeholder="Search for people & companies" matInput id="serachData" formControlName="serachData" #mytest
              [matAutocomplete]="auto" class="searchBox form-control" (keyup)="getSearchText(mytest.value)"
              [(ngModel)]="name" #filterData #trigger="matAutocompleteTrigger" />
            <div>
            </div>
            <ng-container>
              <mat-autocomplete #auto="matAutocomplete" class="app-search-top cp-search">

                <!-- People group -->
                <mat-optgroup class="app-search cp-group">
                  <h3 class="cp-section-header">
                    <span class="cp-section-label">People</span>
                    <!-- <span class="cp-section-count">{{ userData?.length || 0 }}</span> -->
                    <span class="cp-section-count">{{ userCount || 0 }}</span>
                  </h3>
                  <ng-container *ngIf="searchBarShow && userData?.length > 0;else noPeopleFound">
                    <mat-option *ngFor="let option of userData | slice: 0:3" [value]="option.firstName"
                      (click)="userSelected(option, 'USER')" class="cp-option">
                      <div class="cp-row">
                        <div class="cp-avatar">
                          <img *ngIf="option.userImage" [src]="option.userImage" alt="" />
                          <div *ngIf="!option.userImage" class="circles"
                            [style.background-color]="getColor(option.firstName, option.lastName)">
                            <div class="circle-text" [style.color]="getTextColor(option?.firstName, option?.lastName)">{{ getInitials(option.firstName, option.lastName) }}</div>
                          </div>
                        </div>
                        <span class="cp-name">{{ option.firstName }} {{ option.lastName }}</span>
                        <span class="cp-type-tag cp-type-person">Person</span>
                        <span class="cp-enter-hint">&crarr;</span>
                      </div>
                    </mat-option>
                    <mat-option *ngIf="userData?.length > 3" class="cp-view-more"
                      (click)="$event.stopPropagation(); searchList('USER', trigger)">
                      View all people →
                    </mat-option>
                  </ng-container>
                  <ng-template #noPeopleFound>
                    <mat-option disabled class="cp-empty">
                      <div class="cp-empty-row">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="11" cy="11" r="8"/>
                          <path d="m21 21-4.35-4.35"/>
                        </svg>
                        <span>No people match your search.</span>
                      </div>
                    </mat-option>
                  </ng-template>
                </mat-optgroup>

                <!-- Business group -->
                <mat-optgroup class="app-search cp-group">
                  <h3 class="cp-section-header">
                    <span class="cp-section-label">Business</span>
                    <span class="cp-section-count">{{ businessCount || 0 }}</span>
                  </h3>
                  <ng-container *ngIf="searchBarShow && bunissData?.length > 0;else noBusinessFound">
                    <mat-option *ngFor="let option of bunissData | slice: 0:3" [value]="option.businessName"
                      (click)="businessSelected(option,'BUSINESS_PAGE')" class="cp-option">
                      <div class="cp-row">
                        <div class="cp-avatar cp-avatar-business">
                          <img *ngIf="option.businessLogo1 != null" [src]="option.businessLogo1" alt=""
                            onerror="this.src='assets/images/gallery/company.png';" />
                          <img *ngIf="option.businessLogo1 == null" src="assets/images/gallery/company.png" alt="" />
                        </div>
                        <span class="cp-name">{{ option.businessName }}</span>
                        <span class="cp-type-tag cp-type-business">Company</span>
                        <span class="cp-enter-hint">&crarr;</span>
                      </div>
                    </mat-option>
                    <mat-option *ngIf="bunissData?.length > 3" class="cp-view-more"
                      (click)="$event.stopPropagation(); searchList('BUSINESS_PAGE', trigger)">
                      View all companies →
                    </mat-option>
                  </ng-container>
                  <ng-template #noBusinessFound>
                    <mat-option disabled class="cp-empty">
                      <div class="cp-empty-row">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="4" y="2" width="16" height="20" rx="2"/>
                          <path d="M9 22v-4h6v4"/>
                          <path d="M8 6h.01"/>
                          <path d="M16 6h.01"/>
                          <path d="M12 6h.01"/>
                          <path d="M12 10h.01"/>
                          <path d="M12 14h.01"/>
                          <path d="M16 10h.01"/>
                          <path d="M16 14h.01"/>
                          <path d="M8 10h.01"/>
                          <path d="M8 14h.01"/>
                        </svg>
                        <span>No businesses match your search.</span>
                      </div>
                    </mat-option>
                  </ng-template>
                </mat-optgroup>

                <div class="cp-footer" *ngIf="searchBarShow && (userData?.length > 0 || bunissData?.length > 0)">
                  <button type="button" class="cp-view-all-btn" (click)="searchList('ALL', trigger)">
                    View all results <span class="cp-arrow">→</span>
                  </button>
                </div>
              </mat-autocomplete>
            </ng-container>
          </div>
        </form>
        <div class="navbar-right">
          <ul class="nav navbar-nav no-borders">
            <li id="four" [class.axtive]="pageName == 'landingPage'" ngbDropdown
              display="dynamic" class="menu-item" (click)="selectMenu('landingPage')" title="Home">
              <a id="home" class="headertext">
                <!-- <ng-icon name="tablerHome" aria-hidden="true"></ng-icon> -->
                <ng-icon name="tablerHome" style="font-size: 20px;"></ng-icon>
                Home
              </a>
            </li>
            <li joyrideStep="step.jobmenu" [title]="getTourData('step.jobmenu','title')"
              [text]="getTourData('step.jobmenu','text')" id="five" [class.axtive]="pageName == 'newjobs'"
              ngbDropdown display="dynamic" class="menu-item" (click)="selectMenu('newjobs')" title="Jobs"
              (done)="onLandingTourStepDone($event)">
              <a id="jobs" class="svg-outline-filled headertext">
                <ng-icon name="tablerBriefcase" style="font-size: 20px;"></ng-icon>
                Jobs
              </a>
            </li>
            <li joyrideStep="step.candidateMenu" [title]="getTourData('step.candidateMenu','title')"
              [text]="getTourData('step.candidateMenu','text')" [class.axtive]="pageName == 'newcandidates'"
              ngbDropdown display="dynamic" class="menu-item" (click)="selectMenu('newcandidates')" title="Candidates">
              <a id="candidates" class="headertext">
                <ng-icon name="tablerUsers" style="font-size: 20px;"></ng-icon>
                Candidates
              </a>
            </li>

            <!-- <li ngbDropdown class="menu-item" title="Admin" [class.axtive]="pageName == 'admin'"
              *ngIf="userType!='JOB_SEEKER'" (click)="openUserManagement()">
              <a id="admin" class="headertext">
                <svg width="20px" height="20px" fill="#9f9b9b" class="admin-svg" viewBox="0 0 36 36" version="1.1"
                  preserveAspectRatio="xMidYMid meet">
                  <path class="admin-svg-path"
                    d="M14.68,14.81a6.76,6.76,0,1,1,6.76-6.75A6.77,6.77,0,0,1,14.68,14.81Zm0-11.51a4.76,4.76,0,1,0,4.76,4.76A4.76,4.76,0,0,0,14.68,3.3Z">
                  </path>
                  <path class="admin-svg-path"
                    d="M16.42,31.68A2.14,2.14,0,0,1,15.8,30H4V24.22a14.81,14.81,0,0,1,11.09-4.68l.72,0a2.2,2.2,0,0,1,.62-1.85l.12-.11c-.47,0-1-.06-1.46-.06A16.47,16.47,0,0,0,2.2,23.26a1,1,0,0,0-.2.6V30a2,2,0,0,0,2,2H16.7Z">
                  </path>
                  <path class="admin-svg-path" d="M26.87,16.29a.37.37,0,0,1,.15,0,.42.42,0,0,0-.15,0Z"></path>
                  <path class="admin-svg-path"
                    d="M33.68,23.32l-2-.61a7.21,7.21,0,0,0-.58-1.41l1-1.86A.38.38,0,0,0,32,19l-1.45-1.45a.36.36,0,0,0-.44-.07l-1.84,1a7.15,7.15,0,0,0-1.43-.61l-.61-2a.36.36,0,0,0-.36-.24H23.82a.36.36,0,0,0-.35.26l-.61,2a7,7,0,0,0-1.44.6l-1.82-1a.35.35,0,0,0-.43.07L17.69,19a.38.38,0,0,0-.06.44l1,1.82A6.77,6.77,0,0,0,18,22.69l-2,.6a.36.36,0,0,0-.26.35v2.05A.35.35,0,0,0,16,26l2,.61a7,7,0,0,0,.6,1.41l-1,1.91a.36.36,0,0,0,.06.43l1.45,1.45a.38.38,0,0,0,.44.07l1.87-1a7.09,7.09,0,0,0,1.4.57l.6,2a.38.38,0,0,0,.35.26h2.05a.37.37,0,0,0,.35-.26l.61-2.05a6.92,6.92,0,0,0,1.38-.57l1.89,1a.36.36,0,0,0,.43-.07L32,30.4A.35.35,0,0,0,32,30l-1-1.88a7,7,0,0,0,.58-1.39l2-.61a.36.36,0,0,0,.26-.35V23.67A.36.36,0,0,0,33.68,23.32ZM24.85,28a3.34,3.34,0,1,1,3.33-3.33A3.34,3.34,0,0,1,24.85,28Z">
                  </path>
                </svg>
                Admin
              </a>
            </li> -->


            <li ngbDropdown class="menu-item" title="Messages" [class.axtive]="pageName == 'message'"
              (click)="selectMenu('message')">
              <a id="message" class="headertext">

                <ng-icon name="tablerMessage" style="font-size: 20px;"></ng-icon>
                Messages
                <span class="badge noti-badge" *ngIf="notificationDatasshow?.message > 0">
                  {{notificationDatasshow?.message }}</span>
              </a>
            </li>



            <li [class.axtive]="pageName == 'notification' || notifPanelOpen"
              class="menu-item" title="Notifications" (click)="openNotifPanel()">
              <a id="notifications" class="headertext notification-svg-icon" role="button" tabindex="0">

                <ng-icon name="tablerBell" style="font-size: 20px;"></ng-icon>
                Alerts
                <span class="badge noti-badge" *ngIf="notificationcount> 0">{{
                  notificationcount
                  }}</span>
              </a>
            </li>
            <li ngbDropdown class="menu-item" title="Help" [class.axtive]="pageName == 'help'"
              (click)="selectMenu('help')">
              <a id="help" class="headertext">
                <ng-icon name="tablerHelp" style="font-size: 20px;"></ng-icon>

                Help
              </a>
            </li>

            <!-- Apps Menu (redesigned bento dropdown — see <app-apps-menu>) -->
            <li class="menu-item apps-menu-item">
              <app-apps-menu
                [apps]="appsList"
                [activeAppId]="activeAppId"
                (navigate)="navigateToApp($event)"
                (manage)="onAppsManage()">
              </app-apps-menu>
            </li>

            <li class="menu-item profile-menu-item">
              <app-profile-menu
                [user]="profileUser"
                (toggled)="onProfileMenuToggled($event)"
                (viewProfile)="viewMyProfile()"
                (openCompany)="gotoBusiness()"
                (openAdmin)="openUserManagement()"
                (openPlans)="gotoPlans()"
                (openFaq)="gotoFaq()"
                (openSupport)="ContactAdmin()"
                (logout)="onLogout()"
                (upgradePlan)="gotoPlans()">
              </app-profile-menu>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</div>

<!-- Alerts slider panel -->
<app-notification-panel
  [open]="notifPanelOpen"
  [notifications]="notifPanelList"
  [unreadCount]="notificationcount"
  [loading]="notifPanelLoading"
  [loadingMore]="notifPanelLoadingMore"
  [hasMore]="notifPanelHasMore"
  [canMarkAllRead]="true"
  [markingAllRead]="notifMarkAllReadInFlight"
  (closed)="closeNotifPanel()"
  (viewAll)="onNotifViewAll()"
  (notifClicked)="onNotifItemClick($event)"
  (markAllRead)="onNotifMarkAllRead()"
  (loadMore)="onNotifLoadMore()">
</app-notification-panel>


<ng-template #jobCandidateTemplate>
  <div *ngIf="commonVariables.jobPostingFlag">

    <div class="common-header-flex">
      <div>Create Job</div>
      <button>
        <span id="job_form_close_button" (click)="cancelJob()" class="common-close">&times;</span>
      </button>
    </div>

    <!-- cdkScrollable: registers this modal body with the CDK ScrollDispatcher
         so CDK overlays opened from the form (e.g. datepickers, which use the
         default reposition strategy) track their fields when the form is
         scrolled. The Client Name autocomplete no longer depends on it — its
         CloseOnOutsideScrollStrategy listens for scrolls directly. -->
    <div class="panel-body custom-modal-body" cdkScrollable [ngClass]="callMethod()">
      <form formValues [formGroup]="jobPostForm" formName="landingPagejobPostForm" id="jobfrom"
        class="app-form form-horizontal">
        <div class="app-form">
          <!-- Job Description - First Section with Professional Parsing UI -->
          <div class="row" style="padding: 7px;">
            <div class="col-sm-12">
              <label class="control-label required-field font-bold" style="font-weight:600;">Job Description</label>
              <p class="jd-hint-text">Paste or type your job description below and click "Parse JD" to auto-fill the form fields.</p>

              <div id="jobDescription" formControlName="jobDescription" [ngxSummernote]="jobDescConfig"
                class="note-editor.note-frame">
              </div>

              <!-- Validation Errors -->
              <div style="display: block; width: 100%;float:right;" *ngIf="
                (submit && jobControls.jobDescription?.invalid) ||
                (jobControls.jobDescription?.invalid &&
                  (jobControls.jobDescription?.dirty ||
                    jobControls.jobDescription?.touched))" class="error-msg" style="margin-top:5px">
                <div *ngIf="jobControls.jobDescription?.errors?.required">
                  Job Description is required
                </div>
                <div *ngIf="jobControls.jobDescription?.errors?.minChar">
                  Job Description should at least have {{ JOB_DESCRIPTION.min }} Characters
                </div>
                <div *ngIf="jobControls.jobDescription?.errors?.maxChar">
                  Job Description can have a maximum of {{ JOB_DESCRIPTION.max }} Characters
                </div>
              </div>

              <!-- JD Parsing Action Bar -->
              <div class="jd-parsing-action-bar" style="display: flex; width: 100%;">
                <div class="jd-char-info">
                  <small class="char-limit">Maximum of {{ JOB_DESCRIPTION.max }} Characters allowed</small>
                </div>

                <div class="jd-parsing-controls">
                  <!-- Parse Button - Always visible when content exists -->
                  <button type="button"
                          class="btn btn-primary btn-sm jd-parse-btn"
                          (click)="parseJobDescription()"
                          [disabled]="isJdParsing || !jobControls.jobDescription?.value || jobControls.jobDescription?.value?.trim().length < 100">
                    <span *ngIf="!isJdParsing">
                      <ng-icon name="tablerWand" class="me-1"></ng-icon> Parse JD
                    </span>
                    <span *ngIf="isJdParsing">
                      <ng-icon name="tablerLoader2" class="me-1 spin"></ng-icon>
                      Parsing...
                    </span>
                  </button>

                  <!-- Retry Button - Shows on failure -->
                  <button type="button"
                          class="btn btn-warning btn-sm jd-retry-btn"
                          (click)="parseJobDescription()"
                          *ngIf="jdParseFailed && !isJdParsing">
                    <ng-icon name="tablerRefresh" class="me-1"></ng-icon> Retry Parse
                  </button>
                </div>
              </div>

              <!-- Parsing Status Messages -->
              <div class="jd-parsing-status mt-2">
                <div *ngIf="isJdParsing" class="parsing-status">
                  <ng-icon name="tablerLoader2" class="me-2 spin"></ng-icon>
                  <small class="text-info">Parsing job description...</small>
                </div>

                <div *ngIf="jdParseSuccess && !isJdParsing">
                  <small class="text-info">
                    Note: Please review the filled values before submitting.
                  </small>
                </div>

                <div *ngIf="jdParseSuccess && !isJdParsing" class="success-status">
                  <small class="text-success">
                    <ng-icon name="tablerCheck" class="me-1"></ng-icon>
                    Job description parsed successfully! Form fields have been auto-filled.
                  </small>
                </div>

                <div *ngIf="jdParseFailed && !isJdParsing" class="error-status">
                  <small class="text-danger">
                    <ng-icon name="tablerAlertCircle" class="me-1"></ng-icon>
                    Parsing failed. Please try again or fill the form manually.
                  </small>
                </div>
              </div>
            </div>
          </div>
          
          <div class="form-group row">
            <div class="col-sm-6">
              <label for="clientName" class="control-label required-field font-bold">Job Id</label>
              <input type="text" maxlength="13" name="jobId" disabled id="jobId" formControlName="jobId"
                class="form-control input-sm">
            </div>
            <div class="col-sm-6">
              <label for="currentorganization" [ngClass]="{'required-field': currentOrganisationRequired}"
                class="control-label font-bold">Current Organization
              </label>
              <select class="form-control input-sm" #currentOrganization
                (change)="OnChangeCurrentOrg(currentOrganization.value)" id="jobPostedBehalfOf"
                formControlName="jobPostedBehalfOf" type="text">
                <option value="null" selected disabled>Select Your Current Organization</option>
                <option *ngFor="let organization of jobPostedBehalfOflist" [value]="organization.orgName">
                  {{organization.orgName}}</option>
              </select>
              <div *ngIf="
                        (submit && jobControls.jobPostedBehalfOf.invalid) ||
                        (jobControls.jobPostedBehalfOf.invalid &&
                          (jobControls.jobPostedBehalfOf.dirty ||
                            jobControls.jobPostedBehalfOf.touched))
                      " class="error-msg">
                <div *ngIf="jobControls.jobPostedBehalfOf.errors.required">
                  Current Organization is required
                </div>
              </div>
            </div>
            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label class="control-label required-field font-bold">Client Type</label>
              <select class="form-control input-sm" (change)="onClientTypeChange($event.target.value)" id="clientType"
                formControlName="clientType" type="text">
                <option value="null" selected disabled>Select Your Client Classification</option>
                <option *ngFor="let client of clientTypeList" [value]="client">
                  {{client}}</option>
              </select>
              <div *ngIf="
                        (submit && jobControls.clientType.invalid) ||
                        (jobControls.clientType.invalid &&
                          (jobControls.clientType.dirty ||
                            jobControls.clientType.touched))
                      " class="error-msg">
                <div *ngIf="jobControls.clientType.errors.required">
                  Client Type is required
                </div>
              </div>
              <div class="custom-checkbox">
                <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> Show Client
                  Type
                  <input type="checkbox" name="showClientType" id="showClientType" formControlName="showClientType">
                  <span class="checkmark" title="You can check or uncheck this to show or hide  client type"></span>
                </label>
              </div>
            </div>
            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label for="clientName" class="control-label required-field font-bold">Client Name </label>
              <input type="text" maxlength="76" placeholder="Organization's Name job created for" matInput id="clientName"
                formControlName="clientName" (input)="getOrganisationName(mytest1.value)" #mytest1 #filterData
                debounceTime="1000" class="form-control" [matAutocomplete]="auto1" />
              <div>
                <ng-container>
                  <mat-autocomplete #auto1="matAutocomplete" panelClass="client-name-autocomplete"
                    [hideSingleSelectionIndicator]="true">
                    <!-- Platform Business partition -->
                    <mat-optgroup label="Platform Business"
                      *ngIf="searchBarShow2 && platformOrgList2?.length > 0">
                      <mat-option *ngFor="let option of platformOrgList2 | slice: 0:20" [value]="option.organizationName"
                        (click)="onChngOrg2(option)">
                        <div style="display: grid; row-gap: 0px; line-height: initial;">
                          <div>
                            <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                              {{option.organizationName}}
                            </strong>
                          </div>
                          <div style="    line-height: 10px;">
                            <i>
                              <div style="font-size: 60%;">
                                {{option.address1 }}<span *ngIf="option.address1 && option.address2">{{", "}}</span>
                                {{option.address2}}
                              </div>
                            </i>
                          </div>
                          <div style="    line-height: 10px;">
                            <i>
                              <div style="font-size: 60%;">
                                {{option.street }}<span *ngIf="option.street">{{", "}}</span>
                                {{option.city}}<span *ngIf="option.city">{{", "}}</span>
                                {{option.state}}<span *ngIf="option.state">{{", "}}</span>
                                {{option.countryName}}
                              </div>
                            </i>
                          </div>
                        </div>
                      </mat-option>
                    </mat-optgroup>

                    <!-- Externally-created businesses partition -->
                    <mat-optgroup label="Client Companies"
                      *ngIf="searchBarShow2 && externalOrgList2?.length > 0">
                      <mat-option *ngFor="let option of externalOrgList2 | slice: 0:20"
                        [value]="option.organizationName" (click)="onChngOrg2(option, 'EXTERNAL')">
                        <div style="display: grid; row-gap: 0px; line-height: initial;">
                          <div>
                            <strong style="font-size: 13px; padding: 0px 6px 0px 0px;" class="ellipse">
                              {{option.organizationName}}
                            </strong>
                          </div>
                        </div>
                      </mat-option>
                    </mat-optgroup>

                    <!-- Empty state -->
                    <mat-option *ngIf="searchBarShow2 && clientNameSearched2
                        && (!platformOrgList2 || platformOrgList2.length === 0)
                        && (!externalOrgList2 || externalOrgList2.length === 0)"
                        disabled>
                      <span style="font-size: 12px; color: #888; font-style: italic;">
                        No matching businesses
                      </span>
                    </mat-option>
                  </mat-autocomplete>
                </ng-container>
              </div>
              <div *ngIf=" !noResult && ((submit && jobControls.clientName.invalid) ||
                                   (jobControls.clientName.invalid &&
                                 (jobControls.clientName.dirty || jobControls.clientName.touched)))" class="error-msg">
                <div *ngIf="jobControls.clientName.errors.required">
                  Client Name is required
                </div>
                <div *ngIf="jobControls.clientName.errors.minword">
                  {{FORMERROR.CLIENTNAME_MIN}}
                </div>
                <div *ngIf="jobControls.clientName.errors.maxword">
                  {{FORMERROR.CLIENTNAME_MAX}}
                </div>
              </div>
      
              <div *ngIf="jobControls.clientName.errors?.pattern && jobControls.clientName.touched" class="error-msg">
                Enter valid Client Name
              </div>
      
              <!-- <div *ngIf="noResult && (!jobControls.clientName.dirty || jobControls.clientName.value=='')"
                      class="error-msg">Add new clients for the client type.</div> -->
              <div class="custom-checkbox">
                <label class="checkbox-label font-bold" style="text-align: center;margin-top: -4px;"> Show Client
                  Name
                  <input type="checkbox" name="showClientName" id="showClientName" formControlName="showClientName">
                  <span class="checkmark" title="You can check or uncheck this to show or hide  client name"></span>
                </label>
              </div>
            </div>
            <div class="col-sm-12 pl-0 pr-0 ">
              <div class="col-sm-6" style="padding-bottom: 15px;">
                <label for="jobClassification" class="control-label required-field font-bold">Engagement Type</label>
                <select class="form-control input-sm" id="jobClassification" formControlName="jobClassification" type="text"
                  (change)="onengagementTypeChange($event.target.value)">
                  <option value="null" selected disabled>Select Job Classification</option>
                  <option *ngFor="let classification of engagementTypeList" [value]="classification">
                    {{classification}}</option>
                </select>
                <div *ngIf="
                      (submit && jobControls.jobClassification.invalid) ||
                      (jobControls.jobClassification.invalid &&
                        (jobControls.jobClassification.dirty ||
                          jobControls.jobClassification.touched))
                    " class="error-msg">
                  <div *ngIf="jobControls.jobClassification.errors.required">
                    Job Classification is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px;">
                <label for="jobTitle" class="control-label required-field font-bold">Job Title</label>
                <div [attr.title]="selectedJobTitle">
                  <ng-select class="multiselectlable gs-clear-plain" [items]="candidateJobTitleList" [inputAttrs]="{maxlength: '150'}" [addTag]="true"
                    [hideSelected]="false" [clearable]="true" dropdownPosition="bottom" id="jobTitle" formControlName="jobTitle"
                    [multiple]="false" placeholder="Job Title" [(ngModel)]="selectedJobTitle">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="custom-option multi-line-option" [attr.title]="item">
                        {{ item }}
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                      <div class="selected-item" [attr.title]="item">
                        <span class="ng-value-label">{{ item }}</span>
                      </div>
                    </ng-template>

                  </ng-select>
      
                </div>
                <div *ngIf="
                                      (submit && jobControls.jobTitle.invalid) ||
                                      (jobControls.jobTitle.invalid &&
                                        (jobControls.jobTitle.dirty ||
                                          jobControls.jobTitle.touched))
                                    " class="error-msg">
                  <div *ngIf="jobControls.jobTitle.errors.required">
                    Job Title is required
                  </div>
                  <div *ngIf="jobControls.jobTitle.errors.minword">
                    {{FORMERROR.JOBTITLE_MIN}}
                  </div>
                  <div *ngIf="jobControls.jobTitle.errors.maxword">
                    {{FORMERROR.JOBTITLE_MAX}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-sm-6" style="padding-bottom: 15px;">
                  <label for="primarySkills" class="control-label required-field font-bold">Primary Skills</label>
                  <div>
                    <ng-select class="multiselectlable" [items]="primarySkillsList" [addTag]="true" [hideSelected]="false"
                      dropdownPosition="bottom" id="primarySkills" formControlName="primarySkills" maxSelectedItems="3"
                      [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true" [(ngModel)]="primarySkillsSelected"
                      placeholder="e.g. Java, Spring, Hibernate">
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="ng-select-checkbox-label">
                          <span class="ng-select-checkmark" [class.checked]="item$.selected"
                            [class.disabled]="!item$.selected && primarySkillsSelected?.length==3"></span>
                          <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                        </div>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                        <div class="selected-item" [attr.title]="item">
                          <span class="ng-value-clear remove-icon" (click)="clear(item)">
                            ✕
                          </span>
      
                          <span class="ng-value-label">{{ item }}</span>
                        </div>
                      </ng-template>
                    </ng-select>
                    <div>
                      <small style="font-size: 12px;">Enter no more than 3</small>
                    </div>
                  </div>
                  <div>
                    <div *ngIf="
                          (submit && jobControls.primarySkills.invalid) ||
                          (jobControls.primarySkills.invalid &&
                            (jobControls.primarySkills.dirty ||
                              jobControls.primarySkills.touched))
                        " class="error-msg">
                      <div *ngIf="jobControls.primarySkills.errors.required">
                        Primary Skills is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" style="padding-bottom: 15px;">
                  <label for="secondarySkills" class="control-label  font-bold">Secondary Skills</label>
                  <div>
                    <ng-select class="multiselectlable" [items]="secondarySkillsList" [addTag]="true" [hideSelected]="false"
                      dropdownPosition="bottom" id="secondarySkills" formControlName="secondarySkills" maxSelectedItems="3"
                      [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                      [(ngModel)]="secondarySkillsSelected" placeholder="e.g. Java, Spring, Hibernate">
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="ng-select-checkbox-label">
                          <span class="ng-select-checkmark" [class.checked]="item$.selected"
                            [class.disabled]="!item$.selected && secondarySkillsSelected?.length==3"></span>
                          <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                        </div>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                        <div class="selected-item" [attr.title]="item">
                          <span class="ng-value-clear remove-icon" (click)="clear(item)">
                            ✕
                          </span>
      
                          <span class="ng-value-label">{{ item }}</span>
                        </div>
                      </ng-template>
                    </ng-select>
                    <div>
                      <small style="font-size: 12px;">Enter no more than 3</small>
                    </div>
                  </div>
                  <div style="display:flex">
                  </div>
                </div>
              </div>
            </div>
      
            <div class="row" style="padding: 0 15px !important;">
              <div class="col-sm-6">
                <label for="location" class="control-label required-field font-bold">Country</label>
                <select class="form-control input-sm" id="country" formControlName="country" type="text"
                  (change)="onChangeCountry($event.target.value, 'jobs')">
                  <option value="null" selected disabled>Country</option>
                  <option *ngFor="let country of countryList" [value]="country.countryCode">
                    {{country.countryName}}</option>
                </select>
                <div *ngIf="
                      (submit && jobControls.country.invalid) ||
                      (jobControls.country.invalid &&
                        (jobControls.country.dirty ||
                          jobControls.country.touched))
                    " class="error-msg">
                  <div *ngIf="jobControls.country.errors?.required">
                    Country is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="jobPostForm.value.country=='US'">
                <label for="location" class="control-label required-field font-bold">State</label>
                <select class="form-control input-sm" id="stateUS" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of usStatesList" [value]="state">{{state}}
                  </option>
                </select>
                <div *ngIf="
                  (submit && jobControls.state.invalid) ||
                  (jobControls.state.invalid &&
                    (jobControls.state.dirty ||
                      jobControls.state.touched))
                " class="error-msg">
                  <div *ngIf="jobControls.state.errors?.required">
                    State is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="jobPostForm.value.country=='CA'">
                <label for="location" class="control-label required-field font-bold">State</label>
                <select class="form-control input-sm" id="stateCA" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                  </option>
                </select>
                <div *ngIf="
                  (submit && jobControls.state.invalid) ||
                  (jobControls.state.invalid &&
                    (jobControls.state.dirty ||
                      jobControls.state.touched))
                " class="error-msg">
                  <div *ngIf="jobControls.state.errors?.required">
                    State is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="jobPostForm.value.country=='IN'">
                <label for="location" class="control-label required-field font-bold">State</label>
                <select class="form-control input-sm" id="stateIN" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                  </option>
                </select>
                <div *ngIf="
                  (submit && jobControls.state.invalid) ||
                  (jobControls.state.invalid &&
                    (jobControls.state.dirty ||
                      jobControls.state.touched))
                " class="error-msg">
                  <div *ngIf="jobControls.state.errors?.required">
                    State is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="jobPostForm.value.country=='AU'">
                <label for="location" class="control-label required-field font-bold">State</label>
                <select class="form-control input-sm" id="stateAU" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                  </option>
                </select>
                <div *ngIf="
                  ( jobControls.state.invalid) ||
                  (jobControls.state.invalid &&
                    (jobControls.state.dirty ||
                      jobControls.state.touched))
                " class="error-msg">
                  <div *ngIf="jobControls.state.errors?.required">
                    State is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="jobPostForm.value.country!='AU'&&
                                                          jobPostForm.value.country!='IN'&&
                                                          jobPostForm.value.country!='CA'&&
                                                          jobPostForm.value.country!='US'">
                <label for="location" class="control-label required-field font-bold">State</label>
                <input type="text" maxlength="51" placeholder="State" id="stateOther" formControlName="state"
                  class="form-control input-sm">
                <div *ngIf="
                      (submit && jobControls.state.invalid) ||
                      (jobControls.state.invalid &&
                        (jobControls.state.dirty ||
                          jobControls.state.touched))
                    " class="error-msg w-wrap">
                  <div *ngIf="jobControls.state.errors?.required">
                    State is required
                  </div>
                  <div *ngIf="jobControls.state.errors.maxword">
                    {{FORMERROR.STATE_MAX}}
                  </div>
                </div>
              </div>
            </div>
            <!-- City + Zip in their OWN row (mirrors job-template): with all
                 four location fields in one float row, a Country/State error
                 made that column taller and BS3 float-wrap staggered City into
                 the right half and Zip below-left. -->
            <div class="row" style="padding: 0 15px !important;">
              <div class="col-sm-6">
                <label for="location" class="control-label required-field font-bold">City</label>
                <input type="text" maxlength="51" placeholder="City" id="city" formControlName="city"
                  class="form-control input-sm">
                <div *ngIf="
                        (submit && jobControls.city.invalid) ||
                        (jobControls.city.invalid &&
                          (jobControls.city.dirty ||
                            jobControls.city.touched))
                      " class="error-msg">
                  <div *ngIf="jobControls.city.errors.required">
                    City is required
                  </div>
                  <div *ngIf="jobControls.city.errors.maxword">
                    {{FORMERROR.CITY_MAX}}
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <label for="location" class="control-label required-field font-bold">Zip Code</label>
                <input type="text" maxlength="12" placeholder="Zip Code" id="zipCode" formControlName="zipCode"
                  class="form-control input-sm">
                <div *ngIf="
                        (submit && jobControls.zipCode.invalid) ||
                        (jobControls.zipCode.invalid &&
                          (jobControls.zipCode.dirty ||
                            jobControls.zipCode.touched))
                      " class="error-msg">
                  <div *ngIf="jobControls.zipCode.errors.required">
                    Zipcode is required
                  </div>
                  <div class="w-wrap" *ngIf="jobControls.zipCode.errors.minword">
                    {{FORMERROR.ZIPCODE_MIN}}
                  </div>
                  <div class="w-wrap" *ngIf="jobControls.zipCode.errors.maxword">
                    {{FORMERROR.ZIPCODE_MAX}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12" style="margin-left: 15px;">
                <label for="duration" class="control-label required-field font-bold"
                  style="margin-left: 0px;">Duration</label>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px;padding-left: 30px;">
                <select type="text" id="duration" formControlName="duration" class="form-control input-sm">
                  <option value=null disabled [selected]=true>Duration</option>
                  <option *ngFor="let year of years" [value]="year">{{year}}</option>
                </select>
                <div *ngIf="(submit && jobControls.duration.invalid || jobControls.duration.touched)" class="error-msg">
                  <div *ngIf="jobControls.duration.errors?.required">
                    Duration is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px;padding-right: 30px;">
                <select type="text" id="durationType" formControlName="durationType" class="form-control input-sm">
                  <option value=null disabled selected hidden>Type</option>
                  <option *ngFor="let durationType of durationTypeList" [value]="durationType">
                    {{durationType === 'Year' ? 'Years' : durationType}}
                  </option>
                </select>
                <div *ngIf="(submit && jobControls.durationType.invalid || jobControls.durationType.touched)"
                  class="error-msg w-wrap">
                  <div *ngIf="jobControls.durationType.errors?.required">
                    DurationType is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12" style="margin-left: 15px;">
                <label for="experiencerequired" id="mi-16" class="control-label required-field font-bold"
                  style="margin-left: 0px">Required Years of
                  Experience</label>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px; padding-left: 30px;">
                <select type="text" id="experienceFrom" formControlName="experienceFrom" class="form-control input-sm">
                  <option value=null disabled [selected]=true>From</option>
                  <option *ngFor="let year of years" [value]="year" [disabled]="validateBeginning(year)">{{year}}
                  </option>
                </select>
                <div *ngIf="
                     (submit && jobControls.experienceFrom.invalid) ||
                     (jobControls.experienceFrom.invalid &&
                       (jobControls.experienceFrom.dirty ||
                         jobControls.experienceFrom.touched))
                   " class="error-msg">
                  <div *ngIf="jobControls.experienceFrom.errors?.required">
                    From Year is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-bottom: 15px; padding-right: 30px;">
                <select type="text" id="experienceTo" formControlName="experienceTo" class="form-control input-sm">
                  <option value=null disabled [selected]=true>To</option>
                  <option *ngFor="let year of Toyears" [value]="year" [disabled]="validateLast(year)">{{year}}
                  </option>
                </select>
                <div *ngIf="
                         (submit && jobControls.experienceTo.invalid) ||
                         (jobControls.experienceTo.invalid &&
                           (jobControls.experienceTo.dirty ||
                             jobControls.experienceTo.touched))
                       " class="error-msg">
                  <div *ngIf="jobControls.experienceTo.errors?.required">
                    To Year is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-bottom: 15px;padding-left: 30px !important;">
                <label for="payType" class="control-label required-field font-bold">Pay Type</label>
                <select (change)="onChangePayType($event.target.value, 'jobs')" type="text" id="payType"
                  formControlName="payType" class="form-control input-sm">
                  <option value="null" disabled selected hidden>Choose Type</option>
                  <option *ngFor="let list of payTypeList" [value]="list">{{list}}</option>
                </select>
                <div *ngIf="
                                              (submit && jobControls.payType.invalid) ||
                                              (jobControls.payType.invalid &&
                                                (jobControls.payType.dirty ||
                                                  jobControls.payType.touched))
                                      " class="error-msg">
                  <div style="position: relative; top: 4px;" *ngIf="jobControls.payType.errors?.required">
                    Pay Type is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-right:30px;">
                <label for="workMode" class="control-label required-field font-bold">Work Mode</label>
                <select class="form-control input-sm" id="workMode" formControlName="workMode" type="text">
                  <option [value]="null" disabled>Select Your Work Mode</option>
                  <option value="Onsite">Onsite</option>
                  <option value="Remote">Remote</option>
                  <option value="Hybrid">Hybrid</option>
                </select>
                <div *ngIf="
                               (submit && jobControls.workMode.invalid) ||
                               (jobControls.workMode.invalid &&
                               (jobControls.workMode.dirty ||
                               jobControls.workMode.touched))  " class="error-msg">
                  <div *ngIf="jobControls.workMode.errors.required">
                    Work Mode is required
                  </div>
                </div>
      
              </div>
            </div>
      
            <div class="col-sm-12">
              <label for="targetRateFrom" class="control-label required-field font-bold">Target Rate
                Range</label>
            </div>
            <div class="col-sm-12 p-0">
              <div class="col-sm-6">
                <div>
                  <input id="myText" (keyup)="onTargetRateTyped($event.target.value, 'jobs')"
                    (keypress)="decimalFilter($event)" type="text" maxlength="9" class="form-control input-sm"
                    placeholder="From" id="targetRate" formControlName="targetRateFrom">
                  <div class="input-group-append">
                    <span class="input-group-text currency-type-1">
                      <label *ngIf="jobPostForm.value.country=='US' || jobPostForm.value.country==null" for="USD"
                        class="currency-type">USD</label>
                      <label *ngIf="jobPostForm.value.country=='IN'" for="INR" class="currency-type">INR</label>
                      <label *ngIf="jobPostForm.value.country=='CA'" for="CAD" class="currency-type">CAD</label>
                      <label *ngIf="jobPostForm.value.country=='AU'" for="AUD" class="currency-type">AUD</label>
                      <label
                        *ngIf="jobPostForm.value.country!='US' && jobPostForm.value.country!='IN' && jobPostForm.value.country!='CA' && jobPostForm.value.country!='AU' && jobPostForm.value.country!=null"
                        for="CUR" class="currency-type">CUR</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="
                                      (submit && jobControls.targetRateFrom.invalid) ||
                                      (jobControls.targetRateFrom.invalid &&
                                        (jobControls.targetRateFrom.dirty ||
                                          jobControls.targetRateFrom.touched))
                                    " class="error-msg">
                  <div *ngIf="jobControls.targetRateFrom.errors?.required">
                    Target Rate is required
                  </div>
                  <div class="w-wrap" *ngIf="jobControls.targetRateFrom.errors?.minword">
                    {{FORMERROR.TARGETRATE_MIN}}
                  </div>
                  <div *ngIf="jobControls.targetRateFrom.errors?.maxword">
                    {{FORMERROR.TARGETRATE_MAX}}
                  </div>
                  <div *ngIf="jobControls.targetRateFrom.errors?.invalidDecimal&&!jobControls.targetRateFrom.errors?.maxword">
                    {{FORMERROR.TARGETRATE_PATTERN}}
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div>
                  <input id="myText" (keyup)="onTargetRateTyped($event.target.value, 'jobs')"
                    (keypress)="decimalFilter($event)" type="text" maxlength="9" class="form-control input-sm"
                    placeholder="To" id="targetRate" formControlName="targetRateTo">
                  <div class="input-group-append">
                    <span class="input-group-text currency-type-2 right-16">
                      <label *ngIf="jobPostForm.value.country=='US' || jobPostForm.value.country==null" for="USD"
                        class="currency-type">USD</label>
                      <label *ngIf="jobPostForm.value.country=='IN'" for="INR" class="currency-type">INR</label>
                      <label *ngIf="jobPostForm.value.country=='CA'" for="CAD" class="currency-type">CAD</label>
                      <label *ngIf="jobPostForm.value.country=='AU'" for="AUD" class="currency-type">AUD</label>
                      <label
                        *ngIf="jobPostForm.value.country!='US' && jobPostForm.value.country!='IN' && jobPostForm.value.country!='CA' && jobPostForm.value.country!='AU' && jobPostForm.value.country!=null"
                        for="CUR" class="currency-type">CUR</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="(submit ) ||
                                      ((jobControls.targetRateTo.dirty ||
                                          jobControls.targetRateTo.touched))
                                    " class="error-msg">
                  <div *ngIf="jobControls.targetRateTo.errors?.required">
                    Target Rate is required
                  </div>
                  <div class="w-wrap" *ngIf="jobControls.targetRateTo.errors?.minword">
                    {{FORMERROR.TARGETRATE_MIN}}
                  </div>
                  <div *ngIf="jobControls.targetRateTo.errors?.maxword">
                    {{FORMERROR.TARGETRATE_MAX}}
                  </div>
                  <div class="w-wrap"
                    *ngIf="jobPostForm.errors && jobPostForm?.errors?.rangevalidation&&!jobControls.targetRateFrom.errors?.invalidDecimal">
                    Invalid target rate range </div>
                  <div *ngIf="jobControls.targetRateTo.errors?.invalidDecimal&&!jobControls.targetRateTo.errors?.maxword">
                    {{FORMERROR.TARGETRATE_PATTERN}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 p-0">
              <div class="col-sm-6">
                <label for="networks" class="control-label required-field font-bold">Publish To</label>
                <ng-select class="multiselectlable" [items]="networkGroups" bindLabel="name" bindValue="id"
                  placeholder="Select networks" [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedNetworks"
                  id="selectedNetworks" formControlName="selectedNetworks" (change)="onNetworkSelectionChange(jobPostForm)">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <ng-container *ngIf="item.type">
                      <ng-container *ngIf="index === 0 || networkGroups[index - 1].type !== item.type">
                        <div class="networktype">{{ item.type }}</div>
                      </ng-container>

                      <div class="ng-select-checkbox-label networkname"
                        [class.marketplace-locked]="(membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1'"
                        [class.permission-disabled]="item.disabled">
                        <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                        <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;" *ngIf="item.disabled"></ng-icon>
                        <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
                      </div>
                    </ng-container>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                    <div class="selected-item" [attr.title]="item.name">
                      <span class="ng-value-clear remove-icon" (click)="clear(item)"
                        *ngIf="!((membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1') && !isNetworkLocked(item.id) && !item.disabled">
                        ✕
                      </span>
                      <ng-icon name="tablerLock" style="font-size:10px;margin-right:4px;color:#8B5CF6;"
                        *ngIf="isNetworkLocked(item.id) && !item.disabled"></ng-icon>
                      <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;"
                        *ngIf="item.disabled"></ng-icon>
                      <span class="ng-value-label">{{ item.name }}</span>
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="(submit && jobPostForm.controls.selectedNetworks.invalid) ||
                                            (jobPostForm.controls.selectedNetworks.invalid &&
                                            (jobPostForm.controls.selectedNetworks.dirty || jobPostForm.controls.selectedNetworks.touched))"
                  class="error-msg">
                  <div *ngIf="jobPostForm.controls.selectedNetworks.errors.required">
                    Publish to is required
                  </div>
                </div>
              </div>
              <div class="col-sm-6" style="padding-top: 15px;">
                <div class="security-clearance-card"
                  [class.active]="jobPostForm.get('securityClearance')?.value">
                  <div class="security-clearance-card__info">
                    <div class="security-clearance-card__icon">
                      <ng-icon name="tablerShieldLock"></ng-icon>
                    </div>
                    <div class="security-clearance-card__text">
                      <span class="security-clearance-card__title">Security Clearance</span>
                    </div>
                  </div>
                  <div class="security-clearance-card__action">
                    <span class="security-clearance-card__status"
                      [class.active]="jobPostForm.get('securityClearance')?.value">
                      {{ jobPostForm.get('securityClearance')?.value ? 'Yes' : 'No' }}
                    </span>
                    <label class="platform-toggle-switch">
                      <input type="checkbox" id="jobSecurityClearance"
                        formControlName="securityClearance" name="securityClearance">
                      <span class="platform-toggle-track">
                        <span class="platform-toggle-thumb"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-12 R-summary">
                    <label class="control-label required-field font-bold">Job Description</label>
                    <div id="jobDescription" formControlName="jobDescription" [ngxSummernote]="config2" class="note-editor.note-frame">
                    </div>
                    <div *ngIf="
                                  (submit && jobControls.jobDescription.invalid) ||
                                  (jobControls.jobDescription.invalid &&
                                  (jobControls.jobDescription.dirty ||
                                    jobControls.jobDescription.touched))" class="error-msg">
                      <div *ngIf="jobControls.jobDescription.errors?.required">
                        Job Description is required
                      </div>
                      <div *ngIf="jobControls.jobDescription.errors.minChar">
                        Job Description should at least have {{ JOB_DESCRIPTION.min }} Characters
                      </div>
                      <div *ngIf="jobControls.jobDescription.errors.maxChar">
                        Job Description can have a maximum of {{ JOB_DESCRIPTION.max }} Characters
                      </div>
                    </div>
                    <small>Maximum of {{ JOB_DESCRIPTION.max }} Characters allowed</small>
                  </div> -->
          </div>
        </div>
      </form>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button id="job_form_cancel_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
            (click)="cancelJob()">Cancel</button>
          <button id="job_form_clear_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
            (click)="jobformreset()">Clear</button>
          <button id="job_form_save_draft_button" class="btn  btn-primary" type="submit" (click)="saveJob('DRAFTED')"
            [disabled]="jobControls.clientName.invalid || jobControls.jobTitle.invalid ||disable_for_draft==true">Save
            as Draft</button>
          <button id="job_form_post_job_button" class="btn  btn-primary" type="submit" (click)="saveJob('ALL')">Post
            Job</button>
        </div>
      </div>
    </div>


  </div>
  <!-- </div> -->
  <!-- credits availability checking -->
  <div>
    <ng-container *ngIf="!showmodel">
      <div class="common-header-flex" *ngIf="commonVariables.creditFlag">
        <div>Insufficient Credits</div>
        <button>
          <span class="common-close" (click)="closeModal_credit()">&times;</span>
        </button>
      </div>
      <div class="panel-body custom-modal-body" *ngIf="commonVariables.creditFlag">
        <div class="form-group row">
          <div class="row alrt-dngr">
            <div class="alert alert-danger addd-dngr" role="alert">
              You do not have enough credits. Please, purchase credits to proceed.
            </div>
          </div>
          <div class="row form-group text-center">
            <img src="assets/icon/not-enough-credits.jpg" alt="" srcset="" class="nocredits" />
          </div>
        </div>
      </div>
      <div class="custom-panel-footer">
        <div class="panel-footer" *ngIf="commonVariables.creditFlag">
          <div class="shifu">
            <button class="btn  btn-primary" type="submit" (click)="routeToCredits()">Purchase Credits</button>
            <button class="btn btn-default" (click)="closeModal()">Cancel</button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- Candidate posting -->
  <div *ngIf="commonVariables.candidatePostingFlag" [ngClass]="callMethod()">
    <div class="common-header-flex">
      <div>Create Candidate</div>
      <div *ngIf="parseSuccess" class="parsed-indicator">
        <ng-icon name="tablerCircleCheck" class="text-success"></ng-icon>
        <small class="text-success">Resume data parsed successfully</small>
      </div>
      <button>
        <span id="candidate_form_close_button" (click)="cancelcloseCandidate()" class="common-close">&times;</span>
      </button>
    </div>

    <div class="panel-body custom-modal-body">
      <form formValues [formGroup]="candidatePostForm" id="candidatefrom" formName="landingPagecandidatePostForm">
        <div class="app-form">
          <div class="form-group">
            <div class="flecs">
              <div class="col-sm-3 grid-display">
                <img *ngIf="fileshow" src="{{fileshow}}" class="candidate-image" alt="">
                <div *ngIf="!fileshow && candidatePostForm.value.firstName && candidatePostForm.value.lastName">
                  <div class="createcandcircles"
                    [style.background-color]="getColor(candidatePostForm.value.firstName, candidatePostForm.value.lastName)">
                    <div style="padding-top: 17px;" class="circle-text" [style.color]="getTextColor(candidatePostForm.value.firstName, candidatePostForm.value.lastName)">
                      {{ getInitials(candidatePostForm.value.firstName, candidatePostForm.value.lastName) }}
                    </div>
                  </div>
                </div>
                <!-- Empty placeholder when no photo and no name entered yet -->
                <img *ngIf="!fileshow && !(candidatePostForm.value.firstName && candidatePostForm.value.lastName)"
                  src="assets/images/userAvatar.png" class="candidate-image" alt="User Avatar" />
            
                  <div>
                    <button id="candidate_form_upload_photo_button" class="btn btn-outline-primary btn-sm" (click)="uploadPhotoHere()"> Upload Photo </button>
                  </div>
                  <b *ngIf="candidatePostForm.value.candidateId != null">{{candidatePostForm.value.candidateId}}</b>
              </div>
              <div class="col-sm-9">
                <div class="dropdox-908"
                     appDnd
                     (fileDropped)="onFileDropped($event)"
                     for="fileDropRef"
                     [ngClass]="{'uploading-disabled': isUploading}">
                  <input
                    #fileDropRef
                    style="display: none"
                    type="file"
                    accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
                    id="fileDropRef"
                    (click)="fileDropRef.value=''"
                    (change)="fileBrowseHandler($event.target.files)"
                    [disabled]="isUploading" />
                    
                  <div class="file-icon-908">
                    <ng-icon name="tablerFileUpload" style="font-size: 36px;"></ng-icon>
                  </div>
                  <div>
                    <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
                  </div>
                  <div>
                    <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
                  </div>
                  <div for="fileDropRef">
                   <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
                  </div>

                  <!-- Upload Progress Bar - Shows immediately during file upload -->
                  <div *ngIf="isUploading" class="upload-progress-container-908">
                    <div class="upload-progress-info-908">
                      <span class="uploading-text-908">Parsing Resume...</span>
                      <span class="upload-percentage-908">{{uploadProgress}}%</span>
                    </div>
                    <div class="progress-bar-wrapper-908">
                      <div class="progress-bar-908" [style.width.%]="uploadProgress"></div>
                    </div>
                  </div>

                  <div *ngIf="fileDragdrop && !isUploading" class="file-preview-908 file-preview-entered-908">
                    <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
                    <ng-icon name="tablerX" class="file-remove-908" (click)="removeFiles()"></ng-icon>
                  </div>

                  <div class="mt-3" *ngIf="fileDragdrop && !isUploading">
                    <!-- Show parsing status when in progress -->
                    <div *ngIf="isParsing" class="parsing-status mb-2">
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <small class="text-info">Parsing resume automatically...</small>
                    </div>

                    <!-- Show retry button only when parsing fails -->
                    <button id="candidate_form_retry_parse_resume_button" type="button"
                            class="btn btn-warning btn-sm"
                            (click)="parseResume()"
                            *ngIf="parseFailed && !isParsing">
                      <ng-icon name="tablerRefresh" class="me-1"></ng-icon>
                      Retry Parse Resume
                    </button>

                    <!-- Show success status when parsing succeeds -->
                    <div *ngIf="parseSuccess && !isParsing" class="success-status">
                      <small class="text-success">
                        <ng-icon name="tablerCircleCheck" class="me-1"></ng-icon>
                        Resume parsed successfully! Form fields have been auto-filled.
                      </small>
                    </div>
                  </div>

                </div>

                <!-- Resume Upload Validation Error Message -->
                <!-- <div *ngIf="(candidateSubmit && !resumeupload) && !fileDragdrop.file" class="error-msg" style="margin-top: 10px;">
                  <div>Resume upload is required</div>
                </div> -->

              </div>
            </div>

            <!-- Parsed Resume Details Section - COMMENTED OUT AS PER CUSTOMER REQUEST
            <div *ngIf="showParsedDetails && parsedResumeData" class="parsed-details-container" style="margin: 20px 0; border: 1px solid #e0e0e0; border-radius: 8px; background-color: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              
              Header with Profile
              <div style="background: linear-gradient(135deg, var(--gs-purple-light) 0%, var(--gs-purple) 100%); color: white; padding: 20px; border-radius: 8px 8px 0 0;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div style="display: flex; align-items: center;">
                    <div style="width: 60px; height: 60px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                      <span style="color: #667eea; font-size: 24px; font-weight: bold;">
                        {{parsedResumeData.personal_info?.name ? (parsedResumeData.personal_info.name.split(' ')[0][0] + (parsedResumeData.personal_info.name.split(' ')[1]?.[0] || '')) : 'CV'}}
                      </span>
                    </div>
                    <div>
                      <h4 style="margin: 0; font-weight: 600;">{{parsedResumeData.personal_info?.name || 'Candidate Name'}}</h4>
                      <p style="margin: 5px 0 0 0; opacity: 0.9; font-size: 14px;">
                        {{parsedResumeData.experience?.[0]?.position || 'Professional'}} • {{parsedResumeData.personal_info?.location || 'Location'}}
                      </p>
                    </div>
                  </div>
                  <button type="button" class="btn btn-light btn-sm" (click)="showParsedDetails = false" style="opacity: 0.9;">
                    <span aria-hidden="true">&times;</span> Close
                  </button>
                </div>
              </div>
              
              Tabs Navigation
              <ul class="nav nav-tabs" style="background: #f8f9fa; margin: 0; padding: 0 15px; border-bottom: 2px solid #dee2e6;">
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeResumeTab === 'overview'" (click)="activeResumeTab = 'overview'" 
                     style="cursor: pointer; padding: 12px 20px; font-weight: 500; color: #495057; border: none; background: transparent;">
                    📊 Overview
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeResumeTab === 'experience'" (click)="activeResumeTab = 'experience'"
                     style="cursor: pointer; padding: 12px 20px; font-weight: 500; color: #495057; border: none; background: transparent;">
                    💼 Experience
                    <span class="badge badge-secondary" style="margin-left: 5px;">{{parsedResumeData.experience?.length || 0}}</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeResumeTab === 'skills'" (click)="activeResumeTab = 'skills'"
                     style="cursor: pointer; padding: 12px 20px; font-weight: 500; color: #495057; border: none; background: transparent;">
                    🔧 Skills
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeResumeTab === 'projects'" (click)="activeResumeTab = 'projects'"
                     style="cursor: pointer; padding: 12px 20px; font-weight: 500; color: #495057; border: none; background: transparent;">
                    🚀 Projects
                    <span class="badge badge-secondary" style="margin-left: 5px;">{{parsedResumeData.projects?.length || 0}}</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeResumeTab === 'education'" (click)="activeResumeTab = 'education'"
                     style="cursor: pointer; padding: 12px 20px; font-weight: 500; color: #495057; border: none; background: transparent;">
                    🎓 Education
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeResumeTab === 'contact'" (click)="activeResumeTab = 'contact'"
                     style="cursor: pointer; padding: 12px 20px; font-weight: 500; color: #495057; border: none; background: transparent;">
                    📧 Contact
                  </a>
                </li>
              </ul>
              
              Tab Content
              <div class="tab-content" style="padding: 20px;">
                
                Overview Tab
                <div *ngIf="activeResumeTab === 'overview'" class="tab-pane active">
                  <div class="row">
                    <div class="col-md-12">
                      <h5 style="color: #667eea; margin-bottom: 15px;">💡 Professional Summary</h5>
                      <p style="line-height: 1.8; color: #495057; background: #f8f9fa; padding: 15px; border-radius: 6px;">
                        {{parsedResumeData.summary || 'No summary available'}}
                      </p>
                    </div>
                  </div>
                  
                  <div class="row mt-4">
                    <div class="col-md-12">
                      <h5 style="color: #667eea; margin-bottom: 15px;">📊 Quick Stats</h5>
                      <div class="row">
                        <div class="col-md-3">
                          <div style="background: #f8f9fa; padding: 15px; border-radius: 6px; text-align: center;">
                            <div style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Total Experience</div>
                            <div style="color: #495057; font-size: 20px; font-weight: bold; margin-top: 5px;">
                              {{calculateTotalExperience(parsedResumeData.experience)}}+ Years
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div style="background: #f8f9fa; padding: 15px; border-radius: 6px; text-align: center;">
                            <div style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Companies</div>
                            <div style="color: #495057; font-size: 20px; font-weight: bold; margin-top: 5px;">
                              {{parsedResumeData.experience?.length || 0}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div style="background: #f8f9fa; padding: 15px; border-radius: 6px; text-align: center;">
                            <div style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Projects</div>
                            <div style="color: #495057; font-size: 20px; font-weight: bold; margin-top: 5px;">
                              {{parsedResumeData.projects?.length || 0}}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div style="background: #f8f9fa; padding: 15px; border-radius: 6px; text-align: center;">
                            <div style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Skills</div>
                            <div style="color: #495057; font-size: 20px; font-weight: bold; margin-top: 5px;">
                              {{getTotalSkillsCount()}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                Experience Tab
                <div *ngIf="activeResumeTab === 'experience'" class="tab-pane active">
                  <h5 style="color: #667eea; margin-bottom: 20px;">💼 Work Experience</h5>
                  <div *ngIf="parsedResumeData.experience?.length > 0">
                    <div *ngFor="let exp of parsedResumeData.experience; let i = index" 
                         style="margin-bottom: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px; border-left: 4px solid #667eea;">
                      <div style="display: flex; justify-content: space-between; align-items: start;">
                        <div style="flex: 1;">
                          <h6 style="color: #495057; font-weight: 600; margin: 0;">{{exp.position}}</h6>
                          <p style="color: #667eea; margin: 5px 0;">{{exp.company}}</p>
                          <p style="color: #6c757d; font-size: 14px;">
                            📅 {{exp.start_date}} - {{exp.end_date || 'Present'}}
                          </p>
                        </div>
                      </div>
                      <div *ngIf="exp.description" style="margin-top: 10px; color: #495057;">
                        {{exp.description}}
                      </div>
                      <div *ngIf="exp.responsibilities?.length > 0" style="margin-top: 10px;">
                        <p style="font-weight: 500; color: #495057; margin-bottom: 8px;">Key Responsibilities:</p>
                        <ul style="margin: 0; padding-left: 20px; color: #6c757d;">
                          <li *ngFor="let resp of exp.responsibilities" style="margin-bottom: 5px;">{{resp}}</li>
                        </ul>
                      </div>
                      <div *ngIf="exp.achievements?.length > 0" style="margin-top: 10px;">
                        <p style="font-weight: 500; color: #495057; margin-bottom: 8px;">Achievements:</p>
                        <ul style="margin: 0; padding-left: 20px; color: #6c757d;">
                          <li *ngFor="let ach of exp.achievements" style="margin-bottom: 5px;">{{ach}}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!parsedResumeData.experience || parsedResumeData.experience.length === 0" style="text-align: center; padding: 40px; color: #6c757d;">
                    No experience data available
                  </div>
                </div>
                
                Skills Tab
                <div *ngIf="activeResumeTab === 'skills'" class="tab-pane active">
                  <h5 style="color: #667eea; margin-bottom: 20px;">🔧 Skills & Expertise</h5>
                  <div *ngIf="parsedResumeData.skills">
                    <div *ngIf="parsedResumeData.skills.technical_skills?.length > 0" style="margin-bottom: 20px;">
                      <h6 style="color: #495057; margin-bottom: 10px;">Technical Skills</h6>
                      <div>
                        <span *ngFor="let skill of parsedResumeData.skills.technical_skills" 
                              class="badge badge-primary" style="margin: 3px; padding: 8px 12px; font-size: 14px;">{{skill}}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="parsedResumeData.skills.languages?.length > 0" style="margin-bottom: 20px;">
                      <h6 style="color: #495057; margin-bottom: 10px;">Programming Languages</h6>
                      <div>
                        <span *ngFor="let lang of parsedResumeData.skills.languages" 
                              class="badge badge-info" style="margin: 3px; padding: 8px 12px; font-size: 14px;">{{lang}}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="parsedResumeData.skills.frameworks?.length > 0" style="margin-bottom: 20px;">
                      <h6 style="color: #495057; margin-bottom: 10px;">Frameworks & Libraries</h6>
                      <div>
                        <span *ngFor="let framework of parsedResumeData.skills.frameworks" 
                              class="badge badge-success" style="margin: 3px; padding: 8px 12px; font-size: 14px;">{{framework}}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="parsedResumeData.skills.tools?.length > 0" style="margin-bottom: 20px;">
                      <h6 style="color: #495057; margin-bottom: 10px;">Tools & Technologies</h6>
                      <div>
                        <span *ngFor="let tool of parsedResumeData.skills.tools" 
                              class="badge badge-warning" style="margin: 3px; padding: 8px 12px; font-size: 14px;">{{tool}}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="parsedResumeData.skills.databases?.length > 0" style="margin-bottom: 20px;">
                      <h6 style="color: #495057; margin-bottom: 10px;">Databases</h6>
                      <div>
                        <span *ngFor="let db of parsedResumeData.skills.databases" 
                              class="badge badge-secondary" style="margin: 3px; padding: 8px 12px; font-size: 14px;">{{db}}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="parsedResumeData.skills.soft_skills?.length > 0" style="margin-bottom: 20px;">
                      <h6 style="color: #495057; margin-bottom: 10px;">Soft Skills</h6>
                      <div>
                        <span *ngFor="let skill of parsedResumeData.skills.soft_skills" 
                              class="badge badge-light" style="margin: 3px; padding: 8px 12px; font-size: 14px; border: 1px solid #dee2e6;">{{skill}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                Projects Tab
                <div *ngIf="activeResumeTab === 'projects'" class="tab-pane active">
                  <h5 style="color: #667eea; margin-bottom: 20px;">🚀 Projects</h5>
                  <div *ngIf="parsedResumeData.projects?.length > 0">
                    <div *ngFor="let project of parsedResumeData.projects; let i = index" 
                         style="margin-bottom: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px;">
                      <h6 style="color: #495057; font-weight: 600;">{{project.name}}</h6>
                      <p style="color: #6c757d; margin: 10px 0;">{{project.description}}</p>
                      <div *ngIf="project.technologies?.length > 0">
                        <span *ngFor="let tech of project.technologies" 
                              class="badge badge-secondary" style="margin: 2px; font-size: 12px;">{{tech}}</span>
                      </div>
                      <div *ngIf="project.url" style="margin-top: 10px;">
                        <a [href]="project.url" target="_blank" style="color: #667eea; text-decoration: none;">
                          🔗 View Project
                        </a>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!parsedResumeData.projects || parsedResumeData.projects.length === 0" style="text-align: center; padding: 40px; color: #6c757d;">
                    No projects data available
                  </div>
                </div>
                
                Education Tab
                <div *ngIf="activeResumeTab === 'education'" class="tab-pane active">
                  <h5 style="color: #667eea; margin-bottom: 20px;">🎓 Education</h5>
                  <div *ngIf="parsedResumeData.education?.length > 0">
                    <div *ngFor="let edu of parsedResumeData.education" 
                         style="margin-bottom: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px;">
                      <h6 style="color: #495057; font-weight: 600;">{{edu.degree}} in {{edu.field_of_study}}</h6>
                      <p style="color: #667eea; margin: 5px 0;">{{edu.institution}}</p>
                      <p style="color: #6c757d; font-size: 14px;">
                        📅 {{edu.start_date}} - {{edu.end_date}}
                      </p>
                      <p *ngIf="edu.gpa" style="color: #495057; margin-top: 10px;">
                        <strong>GPA:</strong> {{edu.gpa}}
                      </p>
                      <p *ngIf="edu.honors" style="color: #495057;">
                        <strong>Honors:</strong> {{edu.honors}}
                      </p>
                    </div>
                  </div>
                  
                  <div *ngIf="parsedResumeData.certifications?.length > 0" style="margin-top: 30px;">
                    <h6 style="color: #495057; margin-bottom: 15px;">📜 Certifications</h6>
                    <div *ngFor="let cert of parsedResumeData.certifications" 
                         style="margin-bottom: 15px; padding: 15px; background: white; border: 1px solid #dee2e6; border-radius: 6px;">
                      <p style="margin: 0; font-weight: 500; color: #495057;">{{cert.name}}</p>
                      <p style="margin: 5px 0 0 0; color: #6c757d; font-size: 14px;">
                        {{cert.issuer}} • {{cert.date}}
                      </p>
                    </div>
                  </div>
                </div>
                
                Contact Tab
                <div *ngIf="activeResumeTab === 'contact'" class="tab-pane active">
                  <h5 style="color: #667eea; margin-bottom: 20px;">📧 Contact Information</h5>
                  <div *ngIf="parsedResumeData.personal_info" style="background: #f8f9fa; padding: 20px; border-radius: 8px;">
                    <div class="row">
                      <div class="col-md-6">
                        <div style="margin-bottom: 15px;">
                          <label style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Full Name</label>
                          <p style="color: #495057; font-size: 16px; margin: 5px 0;">
                            {{parsedResumeData.personal_info.name || 'Not Available'}}
                          </p>
                        </div>
                        <div style="margin-bottom: 15px;">
                          <label style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Email</label>
                          <p style="color: #495057; font-size: 16px; margin: 5px 0;">
                            {{parsedResumeData.personal_info.email || 'Not Available'}}
                          </p>
                        </div>
                        <div style="margin-bottom: 15px;">
                          <label style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Phone</label>
                          <p style="color: #495057; font-size: 16px; margin: 5px 0;">
                            {{parsedResumeData.personal_info.phone || 'Not Available'}}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div style="margin-bottom: 15px;">
                          <label style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Location</label>
                          <p style="color: #495057; font-size: 16px; margin: 5px 0;">
                            {{parsedResumeData.personal_info.location || 'Not Available'}}
                          </p>
                        </div>
                        <div style="margin-bottom: 15px;">
                          <label style="color: #6c757d; font-size: 12px; text-transform: uppercase;">LinkedIn</label>
                          <p style="color: #495057; font-size: 16px; margin: 5px 0;">
                            {{parsedResumeData.personal_info.linkedin || 'Not Available'}}
                          </p>
                        </div>
                        <div style="margin-bottom: 15px;">
                          <label style="color: #6c757d; font-size: 12px; text-transform: uppercase;">Portfolio</label>
                          <p style="color: #495057; font-size: 16px; margin: 5px 0;">
                            {{parsedResumeData.personal_info.portfolio || 'Not Available'}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div *ngIf="parsedResumeData.languages?.length > 0" style="margin-top: 20px;">
                    <h6 style="color: #495057; margin-bottom: 15px;">🌐 Languages</h6>
                    <div>
                      <span *ngFor="let lang of parsedResumeData.languages" 
                            class="badge badge-light" style="margin: 3px; padding: 8px 12px; font-size: 14px; border: 1px solid #dee2e6;">
                        {{lang}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              
              Action Buttons
              <div style="background: #f8f9fa; padding: 20px; border-top: 1px solid #dee2e6; text-align: center; border-radius: 0 0 8px 8px;">
                <button type="button" class="btn btn-primary" (click)="applyParsedDataToForm()" style="margin-right: 10px;">
                  <ng-icon name="tablerCheck" style="font-size: 16px; margin-right: 5px;"></ng-icon>
                  Apply to Form
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="clearParsedData()">
                  Clear Data
                </button>
              </div>
            </div>
            -->
            <!-- <div class="files-list" *ngIf="fileDragdrop">
              <div class="single-file">
                <div class="info">
                  <h4 class="name">
                    {{ fileDragdrop?.name }}
                  </h4>
                  <p title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
                    <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
                  </p>
                  <div (click)="removeFiles()" title="Remove File" class="tiimes">x</div>
                </div>
              </div>
            </div> -->
            <div class="col-sm-12 p-0">
              <div class="form-group ">
                <div class="col-sm-12 p-0">
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="firstName" class="control-label required-field font-bold">
                      First Name
                    </label>
                    <input (keydown.enter)="$event.preventDefault()" type="text" (keypress)="checkspace($event)"
                      class="form-control input-sm" maxlength="21" placeholder="First Name" id="firstName"
                      formControlName="firstName"
                      [class.parsed-field]="candidatePostForm.get('firstName')?.value && parseSuccess">
                    <div *ngIf="
                                   (candidateSubmit && candidateControls.firstName.invalid) ||
                                   (candidateControls.firstName.invalid &&
                                     (candidateControls.firstName.dirty ||
                                       candidateControls.firstName.touched))
                                 ">
                      <div class="error-msg ps-init" *ngIf="candidateControls.firstName.errors?.required">
                        First Name is required
                      </div>
                    </div>
                    <div
                      *ngIf="candidateControls.firstName.errors?.pattern && !candidateControls.firstName.errors?.maxword"
                      class="error-msg ps-init">
                      {{FORMERROR.FIRSTNAME_VALID}}
                    </div>
                    <div class="error-msg w-wrap ps-init" *ngIf="candidateControls.firstName.errors?.minword">
                      {{FORMERROR.FIRSTNAME_MIN}}
                    </div>
                    <div class="error-msg w-wrap ps-init" *ngIf="candidateControls.firstName.errors?.maxword">
                      {{FORMERROR.FIRSTNAME_MAX}}
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="lastName" class="control-label required-field font-bold">
                      Last Name
                    </label>
                    <input (keydown.enter)="$event.preventDefault()" type="text" class="form-control input-sm"
                      maxlength="41" placeholder="Last Name" id="lastName" formControlName="lastName"
                      (keypress)="checkspace($event)"
                      [class.parsed-field]="candidatePostForm.get('lastName')?.value && parseSuccess">
                    <div *ngIf="
                                   (candidateSubmit && candidateControls.lastName.invalid) ||
                                   (candidateControls.lastName.invalid &&
                                     (candidateControls.lastName.dirty ||
                                       candidateControls.lastName.touched))
                                 ">
                      <div class="error-msg" *ngIf="candidateControls.lastName.errors?.required">
                        Last Name is required
                      </div>
                    </div>
                    <div *ngIf="candidateControls.lastName.errors?.pattern && !candidateControls.lastName.errors?.maxword"
                      class="error-msg ps-init">
                      Enter valid Last Name
                    </div>
                    <div class="error-msg w-wrap ps-init" *ngIf="candidateControls.lastName.errors?.minword">
                      {{FORMERROR.LASTNAME_MIN}}
                    </div>
                    <div class="error-msg w-wrap ps-init" *ngIf="candidateControls.lastName.errors?.maxword">
                      {{FORMERROR.LASTNAME_MAX}}
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 p-0">
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="phone" class="control-label required-field font-bold">Phone</label>
                    <input type="text" class="form-control input-sm" placeholder="Phone" id="phone"
                      formControlName="phone" maxlength="16">
                    <div *ngIf="
                                         (candidateSubmit && candidateControls.phone.invalid) ||
                                         (candidateControls.phone.invalid &&
                                          (candidateControls.phone.dirty ||
                                         candidateControls.phone.touched))
                                         " class="error-msg">
                      <div *ngIf="candidateControls.phone.errors?.required">
                        Phone Number is required
                      </div>
                    </div>
                    <div class="error-msg" *ngIf="candidateControls.phone.errors?.maxword">
                      {{FORMERROR.PHONE_MAX}}
                    </div>
                    <div class="error-msg"
                      *ngIf="candidateControls.phone.errors?.minword && !candidateControls.phone.errors?.pattern">
                      {{FORMERROR.PHONE_MIN}}
                    </div>
                    <div class="error-msg"
                      *ngIf="candidateControls.phone.errors?.pattern && !candidateControls.phone.errors?.maxword">
                      {{FORMERROR.NUMBER_PATTERN}}
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="clientName" class="control-label required-field  font-bold">Email ID</label>
                    <input maxlength="51" (keydown.enter)="$event.preventDefault()" type="text"
                      class="form-control input-sm" (input)="getTheEmailSearchContent($event.target.value)"
                      placeholder="Email ID" id="email" formControlName="email">
                    <div *ngIf="
                            (candidateSubmit && candidateControls.email.invalid) ||
                            (candidateControls.email.invalid &&
                             (candidateControls.email.dirty ||
                            candidateControls.email.touched))
                            " class="w-wrap">
                      <div class="error-msg" *ngIf="candidateControls.email.errors?.required">
                        Email ID is required
                      </div>
                      <div class="error-msg" *ngIf="candidateControls.email.errors.existingEmailAddress">
                        This email already taken
                      </div>
                      <div class="error-msg"
                        *ngIf=" candidateControls.email.errors.pattern && !candidateControls.email.errors.maxword">
                        {{FORMERROR.EMAIL_VALID}}
                      </div>
                      <div class="error-msg" *ngIf="candidateControls.email.errors.maxword">
                        {{FORMERROR.EMAIL_MAX}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 p-0">
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label for="availableIn" class="control-label required-field font-bold">Availability</label>
                    <select class="form-control input-sm" id="availableIn" formControlName="availableIn" type="text"
                      (change)="onChangePeriod($event.target.value)">
                      <option value="null" selected disabled>Select One</option>
                      <option *ngFor="let list of periodList" [value]="list">
                        {{list}}</option>
                    </select>
                    <div *ngIf="
                                    (candidateSubmit && candidateControls.availableIn.invalid) ||
                                    (candidateControls.availableIn.invalid &&
                                      (candidateControls.availableIn.dirty ||
                                        candidateControls.availableIn.touched))
                                  " class="error-msg">
                      <div *ngIf="candidateControls.availableIn.errors?.required">
                        Availablility is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px;">
                    <label class="control-label required-field font-bold">Engagement Type</label>
                    <select class="form-control input-sm" id="engagementType" formControlName="engagementType" type="text">
                      <option value="null" selected disabled>Select Your Engagement Type</option>
                      <option *ngFor="let engagementType of engagementTypeList" [value]="engagementType">
                        {{engagementType}}</option>
                    </select>
                    <div *ngIf="
                           (candidateSubmit && candidateControls.engagementType.invalid) ||
                           (candidateControls.engagementType.invalid &&
                             (candidateControls.engagementType.dirty ||
                               candidateControls.engagementType.touched))
                         " class="error-msg">
                      <div *ngIf="candidateControls.engagementType.errors?.required">
                        Engagement Type is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="padding-bottom: 15px;">
                  <div class="col-sm-6" style="padding-left: 30px;">
                    <label for="title" class="control-label required-field font-bold">Job Title</label>
                    <div  [attr.title]="selectedJobTitle">
                      <ng-select class="multiselectlable gs-clear-plain" [inputAttrs]="{maxlength: '150'}" [items]="candidateJobTitleList"
                        [addTag]="true" [hideSelected]="false" [clearable]="true"
                        dropdownPosition="bottom" id="candidateJobTitle" formControlName="jobTitle" [multiple]="false"
                        placeholder="Job Title" [(ngModel)]="selectedJobTitle">
                        <ng-template ng-option-tmp let-item="item">
                          <div class="custom-option multi-line-option" [attr.title]="item">
                            {{ item }}
                          </div>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                          <div class="selected-item" [attr.title]="item">
                            <span class="ng-value-label">{{ item }}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div *ngIf="
                                            (candidateSubmit && candidateControls.jobTitle.invalid) ||
                                            (candidateControls.jobTitle.invalid &&
                                              (candidateControls.jobTitle.dirty ||
                                                candidateControls.jobTitle.touched))
                                          " class="error-msg">
                      <div *ngIf="candidateControls.jobTitle.errors?.required">
                        Job Title is required
                      </div>
                      <div *ngIf="candidateControls.jobTitle.errors.minword">
                        {{FORMERROR.JOBTITLE_MIN}}
                      </div>
                      <div *ngIf="candidateControls.jobTitle.errors.maxword">
                        {{FORMERROR.JOBTITLE_MAX}}
                      </div>
                    </div>  
                  </div> 
                  <div class="col-sm-6" style="padding-right: 30px;">
                    <label for="totalExperience" class="control-label required-field font-bold">Total
                      Experience</label>
                    <select type="text" id="totalExperience" formControlName="totalExperience" class="form-control input-sm">
                      <option value=null disabled selected hidden>Select the number of years of experience</option>
                      <option *ngFor="let totalExperience of totalExperienceList" [value]="totalExperience">
                        {{totalExperience}}</option>
                    </select>
                    <div *ngIf="
                                            (candidateSubmit && candidateControls.totalExperience.invalid) ||
                                            (candidateControls.totalExperience.invalid &&
                                              (candidateControls.totalExperience.dirty ||
                                                candidateControls.totalExperience.touched))
                                          " class="error-msg">
                      <div *ngIf="candidateControls.totalExperience.errors?.required">
                        Total Experience is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12" style="padding: 0 30px;">
                       <label for="location" class="control-label required-field font-bold">Current Location</label>
                       <div class="row" style="padding-bottom: 20px;">
                         <div class="col-sm-6" >
                           <select class="form-control input-sm" id="candidateCountry" formControlName="country" type="text"
                             (change)="onChangeCountry($event.target.value, 'candidates')">
                             <option value="null" selected disabled>Country</option>
                             <option *ngFor="let country of countryList" [value]="country.countryCode">
                               {{country.countryName}}</option>
                           </select>
                           <div *ngIf="
                                             (candidateSubmit && candidateControls.country.invalid) ||
                                             (candidateControls.country.invalid &&
                                               (candidateControls.country.dirty ||
                                                 candidateControls.country.touched))
                                           " class="error-msg">
                             <div *ngIf="candidateControls.country.errors?.required">
                               Country is required
                             </div>
                           </div>
                         </div>
                         <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='US'">
                           <select class="form-control input-sm" id="candidateStateUS" formControlName="state" type="text">
                             <option value="null" selected=true disabled>State</option>
                             <option *ngFor="let state of usStatesList" [value]="state">{{state}}
                             </option>
                           </select>
                           <div *ngIf="
                                         (candidateSubmit && candidateControls.state.invalid) ||
                                         (candidateControls.state.invalid &&
                                           (candidateControls.state.dirty ||
                                             candidateControls.state.touched))
                                       " class="error-msg">
                             <div *ngIf="candidateControls.state.errors?.required">
                               State is required
                             </div>
                           </div>
                         </div>
                         <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='CA'">
                           <select class="form-control input-sm" id="candidateStateCA" formControlName="state" type="text">
                             <option value="null" selected=true disabled>State</option>
                             <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                             </option>
                           </select>
                           <div *ngIf="
                                         (candidateSubmit && candidateControls.state.invalid) ||
                                         (candidateControls.state.invalid &&
                                           (candidateControls.state.dirty ||
                                             candidateControls.state.touched))
                                       " class="error-msg">
                             <div *ngIf="candidateControls.state.errors?.required">
                               State is required
                             </div>
                           </div>
                         </div>
                         <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='IN'">
                           <select class="form-control input-sm" id="candidateStateIN" formControlName="state" type="text">
                             <option value="null" selected=true disabled>State</option>
                             <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                             </option>
                           </select>
                           <div *ngIf="
                                         (candidateSubmit && candidateControls.state.invalid) ||
                                         (candidateControls.state.invalid &&
                                           (candidateControls.state.dirty ||
                                             candidateControls.state.touched))
                                       " class="error-msg">
                             <div *ngIf="candidateControls.state.errors?.required">
                               State is required
                             </div>
                           </div>
                         </div>
                         <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='AU'">
                           <select class="form-control input-sm" id="candidateStateAU" formControlName="state" type="text">
                             <option value="null" selected=true disabled>State</option>
                             <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                             </option>
                           </select>
                           <div *ngIf=" ( candidateControls.state.invalid) ||
                                   (candidateControls.state.invalid &&
                                     (candidateControls.state.dirty
                                     || candidateControls.state.touched))" class="error-msg">
                             <div *ngIf="candidateControls.state.errors?.required">
                               State is required
                             </div>
                           </div>
                         </div>
                         <div class="col-sm-6"
                           *ngIf="candidatePostForm.value.country!='AU'&&
                                                                                 candidatePostForm.value.country!='IN'&&
                                                                                 candidatePostForm.value.country!='CA'&&
                                                                                 candidatePostForm.value.country!='US'">
                           <input maxlength="51" (keydown.enter)="$event.preventDefault()" type="text"
                             placeholder="State" id="candidateStateOther" formControlName="state" class="form-control input-sm">
                           <div *ngIf="
                                             (candidateSubmit && candidateControls.state.invalid) ||
                                             (candidateControls.state.invalid &&
                                               (candidateControls.state.dirty ||
                                                 candidateControls.state.touched)) " class="error-msg">
                             <div *ngIf="candidateControls.state.errors?.required">
                               State is required.
                             </div>
                             <div *ngIf="candidateControls.state.errors.maxword">
                               {{FORMERROR.STATE_MAX}}
                             </div>
                           </div>
                         </div>
                       </div>
                       <div class="row pt-7">
                         <div class="col-sm-6" style="padding-bottom: -25px;">
                           <input maxlength="51" (keydown.enter)="$event.preventDefault()" type="text"
                             placeholder="City" id="candidateCity" formControlName="city" class="form-control input-sm">
                           <div *ngIf="
                                           (candidateSubmit && candidateControls.city.invalid) ||
                                           (candidateControls.city.invalid &&
                                             (candidateControls.city.dirty ||
                                               candidateControls.city.touched))
                                         " class="error-msg">
                             <div *ngIf="candidateControls.city.errors?.required">
                               City is required
                             </div>
                             <div *ngIf="candidateControls.city.errors.maxword">
                               {{FORMERROR.CITY_MAX}}
                             </div>
                           </div>
                         </div>
                         <div class="col-sm-6">
                           <input type="text" maxlength="12" placeholder="Zip Code" id="candidateZipCode" formControlName="zipCode"
                             class="form-control input-sm">
                           <div *ngIf="
                             (candidateSubmit && candidateControls.zipCode.invalid) ||
                             (candidateControls.zipCode.invalid &&
                               (candidateControls.zipCode.dirty ||
                                 candidateControls.zipCode.touched))
                           " class="error-msg">
                             <div *ngIf="candidateControls.zipCode.errors?.required">
                               Zipcode is required
                             </div>
                             <div class="w-wrap" *ngIf="candidateControls.zipCode.errors.minword">
                               {{FORMERROR.ZIPCODE_MIN}}
                             </div>
                             <div class="w-wrap" *ngIf="candidateControls.zipCode.errors.maxword">
                               {{FORMERROR.ZIPCODE_MAX}}
                             </div>
                           </div>
                         </div>
                       </div>
                 </div>
                </div>
                <div class="col-sm-12" style="padding-bottom: 15px">
                  <div class="row">
                    <div class="col-sm-6">
                      <label for="primarySkills" class="control-label required-field font-bold">
                        Primary Skills
                      </label>
                      <div >
                        <ng-select class="multiselectlable" [items]="primarySkillsList" [addTag]="true"
                          [hideSelected]="false" dropdownPosition="bottom" id="candidatePrimarySkills" formControlName="primarySkills"
                          maxSelectedItems="3" [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                          [selectOnTab]="true" [markFirst]="true"
                          placeholder="e.g. Java, Spring, Hibernate" [(ngModel)]="primarySkillsSelected">
                          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="ng-select-checkbox-label">
                              <span class="ng-select-checkmark" [class.checked]="item$.selected" [class.disabled]="!item$.selected && primarySkillsSelected?.length==3"></span>
                              <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                            <div class="selected-item" [attr.title]="item">
                              <span class="ng-value-clear remove-icon" (click)="clear(item)">
                                ✕
                              </span>

                              <span class="ng-value-label">{{ item }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                        <div>
                          <small style="font-size: 12px;">Enter no more than 3</small>
                        </div>
                      </div>
                      <div style="display:flex; float: right;">
                        <div *ngIf="
                                    (candidateSubmit && candidateControls.primarySkills.invalid) ||
                                    (candidateControls.primarySkills.invalid &&
                                      (candidateControls.primarySkills.dirty ||
                                        candidateControls.primarySkills.touched))
                                  " class="error-msg">
                          <div *ngIf="candidateControls.primarySkills.errors?.required">
                            Primary Skills is required
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label for="secondarySkills" class="control-label font-bold">Secondary
                        Skills</label>
                      <div >
                        <ng-select class="multiselectlable" [items]="secondarySkillsList" [addTag]="true"
                          [hideSelected]="false" dropdownPosition="bottom" id="candidateSecondarySkills" formControlName="secondarySkills"
                          maxSelectedItems="3" [multiple]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                          placeholder="e.g. Java, Spring, Hibernate" [(ngModel)]="secondarySkillsSelected">
                          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="ng-select-checkbox-label">
                              <span class="ng-select-checkmark" [class.checked]="item$.selected" [class.disabled]="!item$.selected && secondarySkillsSelected?.length==3"></span>
                              <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                            <div class="selected-item" [attr.title]="item">
                              <span class="ng-value-clear remove-icon" (click)="clear(item)">
                                ✕
                              </span>

                              <span class="ng-value-label">{{ item }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                        <div>
                          <small style="font-size: 12px;">Enter no more than 3</small>
                        </div>
                      </div>
                      <div style="display:flex">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12" style="padding-bottom: 15px;">
                  <div class="row">
                    <div class="col-sm-6">
                      <label for="workAuthorization" class="control-label required-field font-bold">Work
                        Authorization</label>
                      <select [disabled]="workflag" class="form-control input-sm" id="workAuthorization" formControlName="workAuthorization"
                        type="text">
                        <option value="null" selected disabled>Select Work Authorization</option>
                        <option *ngFor="let workAuthorization of workAuthorizationList" [value]="workAuthorization"
                          [disabled]="workAuthorization?.length==0">
                          {{workAuthorization}} </option>
                      </select>
                      <div *ngIf="
                            (candidateSubmit && candidateControls.workAuthorization.invalid) ||
                            (candidateControls.workAuthorization.invalid &&
                              (candidateControls.workAuthorization.dirty ||
                                candidateControls.workAuthorization.touched))
                          " class="error-msg">
                        <div *ngIf="candidateControls.workAuthorization.errors?.required">
                          Work Authorization is required
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-sm-12">
                          <label for="payType" class="control-label required-field font-bold">Pay Type</label>
                          <select (change)="onChangePayType($event.target.value, 'candidates')" type="text"
                            id="candidatePayType" formControlName="payType" class="form-control input-sm">
                            <option [selected]=true value=null disabled>Select Pay Type</option>
                            <option *ngFor="let list of payTypeList" [value]="list">{{list}}</option>
                          </select>
                          <div *ngIf="
                                        (candidateSubmit && candidateControls.payType.invalid) ||
                                        (candidateControls.payType.invalid &&
                                          (candidateControls.payType.dirty ||
                                            candidateControls.payType.touched))
                                      " class="error-msg">
                            <div *ngIf="candidateControls.payType.errors?.required">
                              Pay Type is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <label for="targetRateFrom"
                  class="control-label required-field font-bold">Target Rate
                  Range</label>
                </div>
                <div class="col-sm-12" style="padding-bottom: 15px;">
                    <div class="col-sm-6 pl-0">
                      <div>
                        <input (keyup)="onTargetRateTyped($event.target.value, 'candidates')"
                        (keypress)="decimalFilter($event)" id="myText" type="text" maxlength="9"
                        class="form-control input-sm" placeholder="From" id="targetRate"
                        formControlName="targetRateFrom">
                        <div class="input-group-append">
                          <span class="input-group-text currency-type-1">
                            <label *ngIf="candidatePostForm.value.country=='US' || candidatePostForm.value.country == null"
                              for="USD" class="currency-type"  >USD</label>
                            <label *ngIf="candidatePostForm.value.country=='IN'" for="INR" class="currency-type"  >INR</label>
                            <label *ngIf="candidatePostForm.value.country=='CA'" for="CAD" class="currency-type"  >CAD</label>
                            <label *ngIf="candidatePostForm.value.country=='AU'" for="AUD" class="currency-type"  >AUD</label>
                            <label
                              *ngIf="candidatePostForm.value.country!='US' && candidatePostForm.value.country!='IN' && candidatePostForm.value.country!='CA' && candidatePostForm.value.country!='AU' && candidatePostForm.value.country!=null"
                              for="CUR" class="currency-type" >CUR</label>
                          </span>
                        </div>
                      </div>
                      <div *ngIf="
                                    (candidateSubmit && candidateControls.targetRateFrom.invalid) ||
                                    (candidateControls.targetRateFrom.invalid &&
                                      (candidateControls.targetRateFrom.dirty ||
                                        candidateControls.targetRateFrom.touched))
                                  " class="error-msg">
                        <div *ngIf="candidateControls.targetRateFrom.errors?.required">
                          Target Rate is required
                        </div>
                        <div *ngIf="candidateControls.targetRateFrom.errors.minword">
                          {{FORMERROR.TARGETRATE_MIN}}
                        </div>
                        <div *ngIf="candidateControls.targetRateFrom.errors.maxword">
                          {{FORMERROR.TARGETRATE_MAX}}
                        </div>

                        <div 
                          *ngIf="candidateControls.targetRateFrom.errors?.invalidDecimal&& !candidateControls?.targetRateFrom?.errors?.maxword">
                          {{FORMERROR.TARGETRATE_PATTERN}}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 pr-0">
                      <div >
                        <input (keyup)="onTargetRateTyped($event.target.value, 'candidates')" 
                               id="myText"
                               (keypress)="decimalFilter($event)" 
                               type="text" 
                               maxlength="9" 
                               class="form-control input-sm"
                               placeholder="To" 
                               id="targetRate" 
                               formControlName="targetRateTo">
                        <div class="input-group-append">
                          <span class="input-group-text currency-type-2">
                            <label *ngIf="candidatePostForm.value.country=='US' || candidatePostForm.value.country == null">USD</label>
                            <label *ngIf="candidatePostForm.value.country=='IN'">INR</label>
                            <label *ngIf="candidatePostForm.value.country=='CA'">CAD</label>
                            <label *ngIf="candidatePostForm.value.country=='AU'">AUD</label>
                            <label *ngIf="candidatePostForm.value.country!='US' && candidatePostForm.value.country!='IN' && candidatePostForm.value.country!='CA' && candidatePostForm.value.country!='AU' && candidatePostForm.value.country!=null">CUR</label>
                          </span>
                        </div>
                      </div>
                      
                      <div *ngIf="(candidateSubmit) || ((candidateControls.targetRateTo.dirty || candidateControls.targetRateTo.touched))" 
                           class="error-msg">
                        <div *ngIf="candidateControls?.targetRateTo.errors?.required">
                          Target Rate is required
                        </div>
                        <div *ngIf="candidateControls?.targetRateTo?.errors?.minword">
                          {{FORMERROR.TARGETRATE_MIN}}
                        </div>
                        <div *ngIf="candidateControls?.targetRateTo?.errors?.maxword">
                          {{FORMERROR.TARGETRATE_MAX}}
                        </div>
                        <div *ngIf="candidatePostForm.errors && candidatePostForm?.errors?.rangevalidation && !candidateControls.targetRateFrom.errors?.invalidDecimal">
                          Invalid target rate range
                        </div>
                        <div *ngIf="candidateControls.targetRateTo.errors?.invalidDecimal && !candidateControls?.targetRateTo?.errors?.maxword">
                          {{FORMERROR.TARGETRATE_PATTERN}}
                        </div>
                      </div>
                    </div>
                </div>
                
                <!-- <div class="row"> -->
                  <div class="col-sm-12 p-0">
                    <div class="col-sm-6" >
                      <label for="workMode" class="control-label required-field font-bold">Work Mode</label>
                      <select class="form-control input-sm" id="candidateWorkMode" formControlName="workMode" type="text">
                        <option [value]="null" disabled>Select Your Work Mode</option>
                        <option value="Onsite">Onsite</option>
                        <option value="Remote">Remote</option>
                        <option value="Hybrid">Hybrid</option>
                      </select>
                      <div *ngIf="
                                               (candidateSubmit && candidateControls.workMode.invalid) ||
                                               (candidateControls.workMode.invalid &&
                                               (candidateControls.workMode.dirty ||
                                               candidateControls.workMode.touched))  " class="error-msg">
                        <div *ngIf="candidateControls.workMode.errors.required">
                          Work Mode is required
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6" >
                      <label class="control-label required-field font-bold">Publish To</label>
                      <ng-select class="multiselectlable" [items]="networkGroups" bindLabel="name" bindValue="id"
                        placeholder="Select networks" [multiple]="true" [closeOnSelect]="false"
                        [(ngModel)]="selectedNetworks"
                        id="candidateSelectedNetworks" formControlName="selectedNetworks" (change)="onNetworkSelectionChange(candidatePostForm)">
  
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <ng-container *ngIf="item.type">

                            <ng-container *ngIf="index === 0 || networkGroups[index - 1].type !== item.type">
                              <div class="networktype">{{ item.type }}</div>
                            </ng-container>

                            <div class="ng-select-checkbox-label networkname"
                              [class.marketplace-locked]="(membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1'"
                              [class.permission-disabled]="item.disabled">
                              <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                              <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;" *ngIf="item.disabled"></ng-icon>
                              <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
                            </div>
                          </ng-container>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                          <div class="selected-item" [attr.title]="item.name">
                            <span class="ng-value-clear remove-icon" (click)="clear(item)"
                              *ngIf="!((membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1') && !item.disabled">
                              ✕
                            </span>
                            <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;"
                              *ngIf="item.disabled"></ng-icon>
                            <span class="ng-value-label">{{ item.name }}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                      <div *ngIf="
                                        (candidateSubmit && candidateControls.selectedNetworks.invalid) ||
                                        (candidateControls.selectedNetworks.invalid &&
                                          (candidateControls.selectedNetworks.dirty ||
                                          candidateControls.selectedNetworks.touched))
                                      " class="error-msg">
                        <div *ngIf="candidateControls.selectedNetworks.errors.required">
                          Publish to is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px; margin-top: 18px;">
                    <div class="preferred-states-row"
                      [class.preferred-states-row--active]="candidatePostForm.value.otherPrefered == true">
                      <div class="custom-checkbox preferred-states-row__check">
                        <label class="checkbox-label font-bold w-wrap"> Other
                          Preferred States
                          <input type="checkbox" name="otherPrefered" id="otherPrefered"
                            formControlName="otherPrefered" (change)="onOtherPreferedChange($event)">
                          <span class="checkmark"
                            title="You can check or uncheck this to show or hide client type"></span>
                        </label>
                      </div>
                      <div class="preferred-states-row__select"
                        *ngIf="candidatePostForm.value.otherPrefered == true">
                        <ng-select class="multiselectlable"
                          [items]="otherStatesList" [addTag]="true" [hideSelected]="false" dropdownPosition="bottom"
                          [(ngModel)]="otherSelectedStates" id="otherPreferedStates"
                          formControlName="otherPreferedStates" [multiple]="true" [closeOnSelect]="false"
                          [clearSearchOnAdd]="true" placeholder="Select states">
                          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="ng-select-checkbox-label">
                              <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                              <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-label-tmp let-item="item" let-clear="clear">
                            <div class="selected-item" [attr.title]="item">
                              <span class="ng-value-clear remove-icon" (click)="clear(item)">
                                ✕
                              </span>
                       
                              <span class="ng-value-label">{{ item }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" style="padding-bottom: 15px; margin-top: 18px;">
                    <div class="security-clearance-card"
                      [class.active]="candidatePostForm.get('securityClearance')?.value">
                      <div class="security-clearance-card__info">
                        <div class="security-clearance-card__icon">
                          <ng-icon name="tablerShieldLock"></ng-icon>
                        </div>
                        <div class="security-clearance-card__text">
                          <span class="security-clearance-card__title">Security Clearance</span>
                        </div>
                      </div>
                      <div class="security-clearance-card__action">
                        <span class="security-clearance-card__status"
                          [class.active]="candidatePostForm.get('securityClearance')?.value">
                          {{ candidatePostForm.get('securityClearance')?.value ? 'Yes' : 'No' }}
                        </span>
                        <label class="platform-toggle-switch">
                          <input type="checkbox" id="candidateSecurityClearance"
                            formControlName="securityClearance" name="securityClearance">
                          <span class="platform-toggle-track">
                            <span class="platform-toggle-thumb"></span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                <!-- </div> -->
                <!-- <div class="row"> -->
                  <div class="col-sm-12 p-0" *ngIf="userType != 'JOB_SEEKER'" style="padding-bottom: 15px;">
                    <div class="platform-profile-toggle-group">
                      <div class="platform-profile-card"
                        [class.active]="candidatePostForm.get('createCandidateOnPlatform')?.value">
                        <div class="platform-profile-card__info">
                          <div class="platform-profile-card__icon">
                            <ng-icon name="tablerUserPlus"></ng-icon>
                          </div>
                          <div class="platform-profile-card__text">
                            <span class="platform-profile-card__title">Create Candidate Profile on the Platform</span>
                            <span class="platform-profile-card__desc">Publish this candidate to GigSumo so recruiters
                              can discover and engage them directly.</span>
                          </div>
                        </div>
                        <div class="platform-profile-card__action">
                          <span class="platform-profile-card__status"
                            [class.active]="candidatePostForm.get('createCandidateOnPlatform')?.value">
                            {{ candidatePostForm.get('createCandidateOnPlatform')?.value ? 'Yes' : 'No' }}
                          </span>
                          <label class="platform-toggle-switch">
                            <input type="checkbox" name="createCandidateOnPlatform"
                              (click)="createCandidateOnProf($event)" id="createCandidateOnPlatform"
                              formControlName="createCandidateOnPlatform">
                            <span class="platform-toggle-track">
                              <span class="platform-toggle-thumb"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                <!-- </div> -->
              

              </div>
            </div>

            <div class="col-sm-12 R-summary">
              <label class="control-label required-field font-bold">
                Resume Summary
              </label>
              <div id="resumeSummary" formControlName="resumeSummary" [ngxSummernote]="config2" class="note-editor.note-frame"></div>
              <div *ngIf="
                            (candidateSubmit && candidateControls.resumeSummary.invalid) ||
                            (candidateControls.resumeSummary.invalid &&
                              (candidateControls.resumeSummary.dirty ||
                                candidateControls.resumeSummary.touched))
                          " class="error-msg">
                <div *ngIf="candidateControls.resumeSummary.errors?.required">
                  Resume Summary is required
                </div>
                <div *ngIf="candidateControls.resumeSummary.errors.minChar">
                  Resume summary should at least have {{ RESUME_SUMMARY.min }} Characters
                </div>
                <div *ngIf="candidateControls.resumeSummary.errors.maxChar">
                  Resume Summary can have a maximum of {{ RESUME_SUMMARY.max }} Characters.
                </div>
              </div>
              <small>Maximum of {{ RESUME_SUMMARY.max }} Characters allowed</small>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button id="candidate_form_cancel_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
            (click)="cancelcloseCandidate()">Cancel</button>
          <button id="candidate_form_clear_button" [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
            (click)="candidateformreset()">Clear</button>
          <button id="candidate_form_save_draft_button" class="btn  btn-primary" type="submit" (click)="saveCandidate('DRAFTED')"
            [disabled]="candidateControls.firstName.invalid || candidateControls.lastName.invalid ||disable_for_draft==true">Save
            as Draft</button>
          <button id="candidate_form_make_available_button" class="btn  btn-primary" type="submit" (click)="saveCandidate('ALL')">Make
            Available</button>
        </div>
      </div>
    </div>

  </div>

  <!-- </div> -->
  <!-- work experience validation -->
  <div *ngIf="commonVariables.workExperienceFlag">
    <app-workexperience-modal [header]="'Current Organization Details'" [supportModal]="supportModal"
      (ModalEmitter)="openJobOrCandidate($event,jobCandidateTemplate)" [ButtonName]="'Submit'"
      [content]="showContent" [expValuesReceivedFromOtherComponent]="true"></app-workexperience-modal>

  </div>
  <!-- education validation -->
  <div>
    <div class="custom-panel-heading" *ngIf="commonVariables.educationFlag">
      <div class="panel-heading" *ngIf="commonVariables.educationFlag">
        <div class="row panel-tools">
          <div class="col-sm-2">
            <button type="button" class="close" aria-label="Close" (click)="closeModal()">
              <span style="font-size: 26px;font-weight: 400;color:#fff;" aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="padding-top-0 margin-bottom-5 margin-top-5" style="margin-left: 8px !important;color:#fff;">Add
          Education</div>
      </div>
    </div>
    <div class="panel-body custom-modal-body" *ngIf="commonVariables.educationFlag">
      <div class="form-group row">
        <div class="row alrt-dngr">
          <div class="alert alert-danger addd-dngr" role="alert">
            To be able to create a candidate profile for yourself, you must at least provide your education
            qualifications. Please, fill in
            your education details below to proceed.
          </div>
        </div>
      </div>
      <form [formGroup]="eduForm" class="app-form">
        <div formArrayName="educationDetail">
          <div *ngFor="let work of geteducation.controls; let i  = index; let lastItem = last;">
            <div [formGroupName]="i" class="form-horizontal">
              <div class="row">
                <div class="form-group">
                  <label for="schoolName" class="col-sm-4 control-label required-field font-light">School / College
                    /
                    University</label>
                  <div class="col-sm-7">
                    <div class="row">
                      <div class="col-sm-12">
                        <input placeholder="School Name" class="form-control input-sm max-hight"
                          id="schoolName{{i}}" formControlName="schoolName"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['schoolName'].hasError }"
                          (typeaheadOnSelect)="onChangeSchool($event, i)"
                          (typeaheadNoResults)="changeTypeaheadNoResults(i, 'edu')" [typeahead]="instList"
                          [typeaheadMinLength]="1" typeaheadOptionField="institutionName"
                          [typeaheadItemTemplate]="customItemTemplate1" autocomplete="off"
                          [typeaheadOrderBy]="sortConfigEdu">
                        <ng-template #customItemTemplate1 let-model="item">
                          <span>
                            <strong style="font-size: 14px;">
                              {{model.institutionName}}
                            </strong>
                            <br>
                            <i>
                              <small>
                                {{model.street }}<span *ngIf="model.street">{{","}}</span>
                                {{model.city}}<span *ngIf="model.city">{{","}}</span>
                                {{model.state}}<span *ngIf="model.state">{{","}}</span>
                                {{model.country}}
                              </small>
                            </i>
                          </span>
                        </ng-template>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['schoolName'].hasError ||
                                                          getEducationFormGroup(i).controls['schoolName'].hasError &&
                                                          (getEducationFormGroup(i).controls['schoolName'].dirty ||
                                                          getEducationFormGroup(i).controls['schoolName'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['schoolName'].hasError('required')">
                            School is required</div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="custom-checkbox" title="Check if this is your current education">
                          <label class="checkbox-label font-bold" style="text-align: center">Currently
                            Pursuing
                            <input type="checkbox" (change)="currentlyPursued($event, i)"
                              id="currentlyPursued{{i}}" formControlName="currentlyPursued" name="currentlyPursued"
                              [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['currentlyPursued'].hasError }">
                            <span class="checkmark" title="Check this if you're currently studying here"></span>
                          </label>
                        </div>
                        <div
                          style="position: absolute;  right: 170px; font-size: 12px; color: #c3002f; font-weight: 500;"
                          *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['currentlyPursued'].hasError('validateEduIfChecked')">
                          Currently pursued is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group">
                  <label class="control-label required-field col-sm-4 font-light">Location</label>
                  <div class="col-sm-7">
                    <div class="row form-group">
                      <div class="col-sm-6 ">
                        <select class="form-control input-sm" id="eduCountry{{i}}" formControlName="country" type="text"
                          (change)="onChangeCountry($event.target.value,'edu')"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['country'].hasError }">
                          <option value="null" selected disabled>Country</option>
                          <option *ngFor="let country of countryList" [value]="country.countryCode">
                            {{country.countryName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['country'].hasError ||
                                                          getEducationFormGroup(i).controls['country'].hasError &&
                                                          (getEducationFormGroup(i).controls['country'].dirty ||
                                                          getEducationFormGroup(i).controls['country'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['country'].hasError('required')">
                            Country is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                        <input type="text" maxlength="12" (keypress)="digitKeyOnly($event)" placeholder="Zipcode"
                          id="eduZipcode{{i}}" formControlName="zipcode" class="form-control input-sm" (keyup)="onKeyZip($event,'edu', i)"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError ||
                                                   getEducationFormGroup(i).controls['zipcode'].hasError &&
                                                   (getEducationFormGroup(i).controls['zipcode'].dirty ||
                                                   getEducationFormGroup(i).controls['zipcode'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('pattern')">
                            Numbers only please</div>
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('required')">
                            Zip code is required</div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('minword')">
                            <div class="zip-min"></div>
                          </div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('maxword')">
                            <div class="zip-max"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='IN'">
                        <select class="form-control input-sm" id="eduStateIN{{i}}" formControlName="state" type="text"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                   getEducationFormGroup(i).controls['state'].hasError &&
                                                   (getEducationFormGroup(i).controls['state'].dirty ||
                                                   getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='CA'">
                        <select class="form-control input-sm" id="eduStateCA{{i}}" formControlName="state" type="text"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                   getEducationFormGroup(i).controls['state'].hasError &&
                                                   (getEducationFormGroup(i).controls['state'].dirty ||
                                                   getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='AU'">
                        <select class="form-control input-sm" id="eduStateAU{{i}}" formControlName="state" type="text"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                   getEducationFormGroup(i).controls['state'].hasError &&
                                                   (getEducationFormGroup(i).controls['state'].dirty ||
                                                   getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='AU'&&
                                                                              educationDetail.value[i].country!='CA'&&
                                                                              educationDetail.value[i].country!='IN'&&
                                                                              educationDetail.value[i].country!='US'">
                        <input id="eduStateOther{{i}}" formControlName="state" maxlength="51" class="form-control input-sm" placeholder="State"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                   getEducationFormGroup(i).controls['state'].hasError &&
                                                   (getEducationFormGroup(i).controls['state'].dirty ||
                                                   getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('maxword')">
                            {{FORMERROR.STATE_MAX}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                        <input disabled type="text" placeholder="City" id="eduCityUS{{i}}" formControlName="city"
                          class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError ||
                                                  getEducationFormGroup(i).controls['city'].hasError &&
                                                  (getEducationFormGroup(i).controls['city'].dirty ||
                                                  getEducationFormGroup(i).controls['city'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('required')">
                            City is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='US'">
                        <input type="text" placeholder="City" id="eduCity{{i}}" formControlName="city" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['city'].hasError ||
                                                  getEducationFormGroup(i).controls['city'].hasError &&
                                                  (getEducationFormGroup(i).controls['city'].dirty ||
                                                  getEducationFormGroup(i).controls['city'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('required')">
                            City is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                        <input disabled maxlength="51" id="eduStateUS{{i}}" formControlName="state" class="form-control input-sm"
                          placeholder="State"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].hasError ||
                                                  getEducationFormGroup(i).controls['state'].hasError &&
                                                  (getEducationFormGroup(i).controls['state'].dirty ||
                                                  getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('maxword')">
                            {{FORMERROR.STATE_MAX}}</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='US'">
                        <!-- <input type="text" class="form-control input-sm" placeholder="Zipcode" formControlName="zipcode"> -->
                        <input type="text" maxlength="12" (keypress)="digitKeyOnly($event)" placeholder="Zipcode"
                          id="eduZipcodeNonUS{{i}}" formControlName="zipcode" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError ||
                                                getEducationFormGroup(i).controls['zipcode'].hasError &&
                                                (getEducationFormGroup(i).controls['zipcode'].dirty ||
                                                getEducationFormGroup(i).controls['zipcode'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('pattern')">
                            Numbers only please</div>
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('required')">
                            Zip code is required</div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('minword')">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('maxword')">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <input type="text" placeholder="Street/Road/Nearby Landmark" id="eduStreet{{i}}" formControlName="street"
                          class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['street'].hasError }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['street'].hasError ||
                                              getEducationFormGroup(i).controls['street'].hasError &&
                                              (getEducationFormGroup(i).controls['street'].dirty ||
                                              getEducationFormGroup(i).controls['street'].touched) " class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['street'].hasError('required')">
                            Street is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group">
                  <label for="degree" class="col-sm-4 control-label required-field font-light">Degree</label>
                  <!-- <label for="degree" *ngIf="!commonVariables?.studentFlag"
                                              class="col-sm-4 control-label font-light">Degree</label> -->
                  <div class="col-sm-7">
                    <input type="text" class="form-control input-sm" placeholder="Degree" id="degree{{i}}" formControlName="degree"
                      trim="blur"
                      [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['degree'].hasError }">
                    <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['degree'].hasError ||
                                         getEducationFormGroup(i).controls['degree'].hasError &&
                                         (getEducationFormGroup(i).controls['degree'].dirty ||
                                         getEducationFormGroup(i).controls['degree'].touched) " class="error-msg">
                      <div *ngIf="getEducationFormGroup(i).controls['degree'].hasError('required')">
                        Degree is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group">
                  <label for="speciality" class="col-sm-4 required-field control-label font-light">Speciality</label>
                  <!-- <label for="speciality" *ngIf="!commonVariables?.studentFlag"
                                              class="col-sm-4 control-label font-light">Speciality</label> -->
                  <div class="col-sm-7">
                    <input type="text" class="form-control input-sm" placeholder="Speciality"
                      id="speciality{{i}}" formControlName="speciality" trim="blur"
                      [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['speciality'].hasError }">
                    <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['speciality'].hasError ||
                                          getEducationFormGroup(i).controls['speciality'].hasError &&
                                          (getEducationFormGroup(i).controls['speciality'].dirty ||
                                          getEducationFormGroup(i).controls['speciality'].touched) " class="error-msg">
                      <div *ngIf="getEducationFormGroup(i).controls['speciality'].hasError('required')">
                        Speciality is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group">
                  <label class="control-label required-field col-sm-4 font-light">From
                    Date</label>
                  <div class="col-sm-7">
                    <div class="row">
                      <div class="col-sm-6">
                        <select type="text" id="startMonth{{i}}" formControlName="startMonth" class="form-control input-sm"
                          (change)="monthChange(i,'edu')"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['startMonth'].hasError }">
                          <option value="null" selected disabled>Month</option>
                          <option *ngFor="let month of months" [value]="month.name"
                            [disabled]="checkMonth1(month.code,i,'edu')">{{month.name}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['startMonth'].hasError ||
                                          getEducationFormGroup(i).controls['startMonth'].hasError &&
                                          (getEducationFormGroup(i).controls['startMonth'].dirty ||
                                          getEducationFormGroup(i).controls['startMonth'].touched) " class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['startMonth'].hasError('required')">
                            From date is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <select type="text" id="startYear{{i}}" formControlName="startYear" class="form-control input-sm"
                          (change)="yearChange(i,$event,'edu',null)"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['startYear'].hasError }">
                          <option value="null" disabled>Year</option>
                          <option *ngFor="let year of years1" [value]="year">{{year}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['startYear'].hasError ||
                                                    getEducationFormGroup(i).controls['startYear'].hasError &&
                                                    (getEducationFormGroup(i).controls['startYear'].dirty ||
                                                    getEducationFormGroup(i).controls['startYear'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['startYear'].hasError('required')">
                            Start Year is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="educationDetail.value[i].currentlyPursued==false">
                <div class="form-group">
                  <label class="control-label required-field col-sm-4 font-light">To Date</label>
                  <!-- <label *ngIf="!commonVariables?.studentFlag" class="control-label  col-sm-4 font-light">To
                                              Date</label> -->
                  <div class="col-sm-7">
                    <div class="row form-group">
                      <div class="col-sm-6">
                        <select type="text" id="endMonth{{i}}" formControlName="endMonth" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['endMonth'].hasError }">
                          <option value="null" selected disabled>Month</option>
                          <option *ngFor="let month of months" [value]="month.name"
                            [disabled]="checkMonth(month.code,i,'edu')">{{month.name}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['endMonth'].hasError ||
                                                  getEducationFormGroup(i).controls['endMonth'].hasError &&
                                                  (getEducationFormGroup(i).controls['endMonth'].dirty ||
                                                  getEducationFormGroup(i).controls['endMonth'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['endMonth'].hasError('required')">
                            To date is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <select type="text" id="endYear{{i}}" formControlName="endYear" class="form-control input-sm"
                          (change)="onChangeYear(i,'edu', null)"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['endYear'].hasError }">
                          <option value="null" disabled>Year</option>
                          <option *ngFor="let year of years1" [value]="year" [disabled]="checkYear(year,i,'edu')">
                            {{year}}</option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['endYear'].hasError ||
                                                      getEducationFormGroup(i).controls['endYear'].hasError &&
                                                      (getEducationFormGroup(i).controls['endYear'].dirty ||
                                                      getEducationFormGroup(i).controls['endYear'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['endYear'].hasError('required')">
                            End Year is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <hr *ngIf="!lastItem"> -->
          </div>
        </div>
      </form>
    </div>
    <div class="custom-panel-footer" *ngIf="commonVariables.educationFlag">
      <div class="panel-footer">
        <div class="shifu">
          <button class="btn  btn-primary" type="submit" (click)="saveEducation()">Add
            Education</button>
          <button class="btn btn-default" (click)="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Email Domain Validation -->

  <div class="panel-body" *ngIf="commonVariables.emailDomainValidation">
    <form [formGroup]="domainForm" action="">
      <div class="app-form">
        <div class="form-group row">

          <div class="row alrt-dngr">

            <div class="alert alert-danger addd-dngr" role="alert">
              You need to have a business email address as your primary email on your profile to be able to create a
              business/Job/Candidate.<br><br>
              Please update the same and try again.<br><br>
              A validation code will be sent to the business email address provided.<br><br>&nbsp; &nbsp; &nbsp; &nbsp;
              * You can always have your generic email address as secondary email, to regain access to your profile once
              you change organizations.<br><br>

            </div>
          </div>

          <div class="col-sm-6" style="padding-bottom: 15px;">
            <label for="priEmail" class="control-label font-bold">Primary Email</label>
            <div>{{primaryEmail}}</div>
          </div>
          <div class="col-sm-6" style="padding-bottom: 15px;">
            <label for="secEmail" class="control-label font-bold">Secondary Email</label>

            <div>{{secondaryEmail}}</div>

            ]
          </div>


          <div class="col-sm-12" *ngIf="!otpEmailSent" style="padding-bottom: 15px;">
            <label for="swapEmail" class="control-label required-field font-bold">Business Email
              Address</label>
            <input class="form-control input-sm" id="swapEmail" formControlName="swapEmail" type="text">
            <div *ngIf="
                (domainValidatorSubmit && domainControl.swapEmail.invalid) ||
                (domainControl.swapEmail.invalid &&
                  (domainControl.swapEmail.dirty ||
                    domainControl.swapEmail.touched))
              " class="error-msg">
              <div *ngIf="domainControl.swapEmail.errors?.required">
                Business Email is required
              </div>
              <div *ngIf="domainControl.swapEmail.errors.genericDomain">
                Please, enter a business email domain
              </div>
              <div *ngIf="domainControl.swapEmail.errors.pattern">
                Enter a vaild email address
              </div>
              <div *ngIf="domainControl.swapEmail.errors.emailExistsAlready">
                That email is taken already. Please, enter a different one.
              </div>
            </div>
          </div>
          <div class="col-sm-12" style="display:flex; column-gap: 13px;
          align-items: center;" *ngIf="otpEmailSent">
            <label for="">Business Email</label>
            {{domainForm.value.swapEmail}}
          </div>
          <div class="row alrt-dngr">
            <div *ngIf="otpEmailSent" class="alert alert-info addd-dngr" role="alert">
              An authentication code has been sent to your business email. Please, enter it below.
            </div>
          </div>
          <div class="col-sm-12" *ngIf="otpEmailSent">
            <label for="domainValidationOtp" class="control-label required-field font-bold">Enter OTP</label>
            <input class="form-control input-sm" id="domainValidationOtp" formControlName="domainValidationOtp" type="text">
            <div *ngIf="
                  (domainValidatorSubmit && domainControl.domainValidationOtp.invalid) ||
                  (domainControl.domainValidationOtp.invalid &&
                    (domainControl.domainValidationOtp.dirty ||
                      domainControl.domainValidationOtp.touched))
                " class="error-msg">
              <div *ngIf="domainControl.domainValidationOtp.errors?.required">
                Please, enter OTP.
              </div>
              <div *ngIf="domainControl.domainValidationOtp.errors.wrongDomainValidationOtp">
                Incorrect OTP. Enter the right one.
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="custom-panel-footer" *ngIf="commonVariables.emailDomainValidation">
    <div class="panel-footer">
      <div class="shifu">
        <button class="btn  btn-primary"
          *ngIf="(userType == 'BENCH_RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'CANDIDATE' && !otpEmailSent"
          type="submit" (click)="proceedAfterValidation('CANDIDATE')">Proceed</button>
        <button class="btn  btn-primary"
          *ngIf="(userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'JOBS' && !otpEmailSent"
          type="submit" (click)="proceedAfterValidation('JOBS')">Proceed</button>
        <button
          *ngIf="(userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'JOBS' && !otpEmailSent"
          class="btn btn-default" (click)="closeModal()">Cancel</button>
        <button
          *ngIf="(userType == 'BENCH_RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'CANDIDATE' && !otpEmailSent"
          class="btn btn-default" (click)="closeModal()">Cancel</button>
        <button class="btn  btn-primary"
          *ngIf="(userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'JOBS' &&  otpEmailSent"
          type="submit" (click)="validateOtp('JOBS')">Validate OTP</button>
        <button class="btn  btn-primary"
          *ngIf="(userType == 'BENCH_RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION') && currentEntity == 'CANDIDATE' &&  otpEmailSent"
          type="submit" (click)="validateOtp('CANDIDATE')">Validate OTP</button>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #profilePhotoUpload>
  <!-- <div class="modal-headerphoto">
    <button type="button" style="font-size: 31px;padding-right: 17px;font-weight: 400;padding-top: 7px;"
      class="close pull-right" aria-label="Close" (click)="closePhoto2()">
      <span aria-hidden="true">&times;</span>
    </button>
    <label style="margin: 6px 10px 14px 10px;padding-top:10px;font-size: 17px;">Profile Photo</label>
  </div> -->
  <div class="common-header-flex">
    <div>Profile Photo</div>
    <button><span class="common-close" (click)="closePhoto2()" aria-hidden="true">&times;</span></button>
  </div>
  <hr style="margin: 0px !important;">
  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
      format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>
  </div>

  <div class="modal-footer" style="border-radius: 5px !important;">
    <button class="btn btn-default m-r-18 w70" (click)="closePhoto2()">Cancel</button>
    <button class="btn primary-btn m-r-18 w70" (click)="imageLoaded2()">Apply</button>
  </div>
</ng-template>

<ng-template #welcometour>
  <div class="welcomemodel">
    <div class="welcome-container">
      <button type="button" class="close" aria-label="Close" (click)="closeTour()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h1>Welcome to GigSumo!</h1>
      <p>GigSumo network enables you to connect with recruiters and bench sales contacts and showcase your
        jobs/candidates to make quick placements, <span class="highlight">all in one place.</span></p>
      <p><span class="highlight">Let's start with a quick product Tour</span></p>
      <p>We will have you up and running in no time.</p>
      <div class="welcome-buttons">
        <button class="primary-button" (click)="startUI()">Get started</button>
        <button class="secondary-button" (click)="closeTour()">Show me later</button>
      </div>
      <img class="paper-plane" src="assets/icon/paper-plane.png" alt="Paper Plane">
    </div>
  </div>

</ng-template>

<app-timezonepopup (modalopen)="timezonepopup()" (response)="modelclose($event)" *ngIf="showModal"></app-timezonepopup>

<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" style="z-index: -1;"
  [messageDataPass]="messageData"> </app-message-widget>


<app-notifier [title]="notificationTitle" [message]="notificationContent"
  [executeShow]="showSecondaryAlert" [buttonName]="notificationButtonName"></app-notifier>

<!-- Candidate Tab Form Modal Template -->
<ng-template #candidateTabTemplate let-modal>
  <div class="modal-header candidate-modal-header">
    <h4 class="modal-title">Create New Candidate Profile</h4>
    <button type="button" class="btn-close" (click)="onCandidateTabFormCancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body candidate-modal-body">
    <app-candidate-form-tabs
      (onFormSubmit)="onCandidateTabFormSubmit($event)"
      (onFormCancel)="onCandidateTabFormCancel()">
    </app-candidate-form-tabs>
  </div>
</ng-template>
